import * as i0 from '@angular/core';
import { Injectable, Component, ViewChild, InjectionToken, Injector, EventEmitter, Input, Output, inject, ViewEncapsulation, ViewContainerRef, ViewChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/cdk/overlay';
import { OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import * as i2 from '@angular/cdk/portal';
import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import { Subject, fromEvent, startWith, tap, switchMap, map, bufferCount, distinctUntilChanged } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i1$1 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i2$1 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import * as i1$2 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
import * as i5 from '@niceltd/sol/tooltip';
import { TooltipModule } from '@niceltd/sol/tooltip';
import * as i8 from '@angular/forms';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i3 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i4 from '@niceltd/sol/chip';
import { ChipModule } from '@niceltd/sol/chip';
import * as i5$1 from '@niceltd/sol/text-area';
import { TextAreaModule } from '@niceltd/sol/text-area';
import * as i6 from '@niceltd/sol/autocomplete';
import { AutoCompleteModule } from '@niceltd/sol/autocomplete';
import * as i7 from '@niceltd/sol/spinner';
import { SpinnerModule } from '@niceltd/sol/spinner';
import { RangeSliderComponent, RangeSliderModule } from '@niceltd/sol/range-slider';
import { Subject as Subject$1 } from 'rxjs/internal/Subject';
import * as i3$1 from '@niceltd/sol/tabs';
import { TabsModule } from '@niceltd/sol/tabs';
import * as i4$1 from '@niceltd/sol/time-duration';
import { TimeDurationModule } from '@niceltd/sol/time-duration';
import * as i2$2 from '@niceltd/sol/svg-sprite-icon';
import { SvgSpriteIconModule } from '@niceltd/sol/svg-sprite-icon';
import * as i3$2 from '@niceltd/sol/select';
import { SelectModule } from '@niceltd/sol/select';
import { DateRange } from '@angular/material/datepicker';
import * as i4$2 from '@niceltd/sol/date-range-picker';
import { DateRangepickerModule } from '@niceltd/sol/date-range-picker';
import * as i4$3 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import { CheckboxModule } from '@niceltd/sol/checkbox';
import { TextInputModule } from '@niceltd/sol/text-input';
import { languageInitializerProvider } from '@niceltd/sol';

// close-overlay event type
const _c0 = ["overlayContent"];
function QueryChipOverlayComponent_ng_template_2_Template(rf, ctx) {}
const _c1 = ["overlayTrigger"];
const _c2 = ["overlayOperatorTrigger"];
function QueryChipComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "path", 13);
    i0.ɵɵelementStart(3, "defs");
    i0.ɵɵelement(4, "rect", 14);
    i0.ɵɵelementEnd()()();
  }
}
function QueryChipComponent_div_5_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("trigger", "mouseenter focus")("overflowTooltip", true)("position", "top-start")("darkMode", false)("interactive", false)("content", ctx_r8.currentOperatorSelectionDisplay)("arrow", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r8.currentOperatorSelectionDisplay);
  }
}
function QueryChipComponent_div_5_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "queryChipOperatorText"));
  }
}
function QueryChipComponent_div_5_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 18);
    i0.ɵɵelement(2, "path", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
const _c3 = a0 => ({
  "overlay-open": a0
});
function QueryChipComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function QueryChipComponent_div_5_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.showOperatorOverlayOnClick());
    })("keypress", function QueryChipComponent_div_5_Template_div_keypress_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.showOperatorOverlayOnEnterOrSpace($event));
    });
    i0.ɵɵelementStart(1, "div", 15, 16);
    i0.ɵɵtemplate(3, QueryChipComponent_div_5_span_3_Template, 2, 8, "span", 8)(4, QueryChipComponent_div_5_span_4_Template, 3, 3, "span", 9)(5, QueryChipComponent_div_5_ng_container_5_Template, 3, 0, "ng-container", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, ctx_r1.operatorOverlayOpen));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.currentOperatorSelectionDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.currentOperatorSelectionDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.canOverlayOpen);
  }
}
function QueryChipComponent_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("trigger", "mouseenter focus")("overflowTooltip", true)("position", "top-start")("darkMode", false)("interactive", false)("content", ctx_r3.currentSelectionDisplay)("arrow", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.currentSelectionDisplay);
  }
}
function QueryChipComponent_span_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "queryChipSelectText"));
  }
}
function QueryChipComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 18);
    i0.ɵɵelement(2, "path", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function QueryChipComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "button", 21);
    i0.ɵɵlistener("click", function QueryChipComponent_div_12_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.removeChip());
    })("keypress", function QueryChipComponent_div_12_Template_button_keypress_1_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.removeChipOnEnterOrSpace($event));
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 22);
    i0.ɵɵelement(4, "path", 23);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "remove") + ": " + ctx_r6.definition.filterName);
  }
}
const _c4 = a0 => ({
  "focus-within-chip": a0
});
const _c5 = ["solChipQueryContainer"];
function TagFilterTypeComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-text-area", 18);
    i0.ɵɵlistener("keydown.enter", function TagFilterTypeComponent_ng_template_3_Template_sol_text_area_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.addChipToContainerFromTextInput($event));
    })("keydown.tab", function TagFilterTypeComponent_ng_template_3_Template_sol_text_area_keydown_tab_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.addChipToContainerFromTextInput($event));
    })("valueChange", function TagFilterTypeComponent_ng_template_3_Template_sol_text_area_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.onValueChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("labelText", "")("placeholder", ctx_r0.queryTagInputPlaceholder)("value", ctx_r0.textInputValue)("disabled", ctx_r0.maxTags <= ctx_r0.tags.length)("minRows", 1)("maxRows", 1)("cols", 70)("wrap", "off")("errorState", ctx_r0.isInputError)("errorMessageText", "")("resizeTextarea", false);
  }
}
function TagFilterTypeComponent_ng_template_5_sol_autocomplete_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "sol-autocomplete-option", 23)(1, "div", 24);
    i0.ɵɵelement(2, "sol-spinner", 25);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isSpinner", ctx_r17.loading)("id", "spinner");
  }
}
function TagFilterTypeComponent_ng_template_5_ng_container_3_sol_autocomplete_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "sol-autocomplete-option", 27);
    i0.ɵɵelement(1, "span", 28);
    i0.ɵɵpipe(2, "solTextHighlighter");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r19 = i0.ɵɵnextContext().$implicit;
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", option_r19)("name", ctx_r20.objectLabel ? option_r19[ctx_r20.objectLabel] : option_r19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(2, 3, ctx_r20.objectLabel ? option_r19[ctx_r20.objectLabel] : option_r19, ctx_r20.searchTerm.value), i0.ɵɵsanitizeHtml);
  }
}
function TagFilterTypeComponent_ng_template_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TagFilterTypeComponent_ng_template_5_ng_container_3_sol_autocomplete_option_1_Template, 3, 6, "sol-autocomplete-option", 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r18.loading);
  }
}
function TagFilterTypeComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 19)(1, "sol-autocomplete", 20);
    i0.ɵɵlistener("optionSelected", function TagFilterTypeComponent_ng_template_5_Template_sol_autocomplete_optionSelected_1_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.addChipToContainerFromAutocomplete($event));
    })("dropdownVisible", function TagFilterTypeComponent_ng_template_5_Template_sol_autocomplete_dropdownVisible_1_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.autocompleteDropdownUpdate($event));
    });
    i0.ɵɵtemplate(2, TagFilterTypeComponent_ng_template_5_sol_autocomplete_option_2_Template, 3, 3, "sol-autocomplete-option", 21)(3, TagFilterTypeComponent_ng_template_5_ng_container_3_Template, 2, 1, "ng-container", 22);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r2.searchTerm)("minimumSearchTextLength", 3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 4, ctx_r2.filteredOptions));
  }
}
function TagFilterTypeComponent_div_7_sol_chip_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-chip", 32);
    i0.ɵɵlistener("closed", function TagFilterTypeComponent_div_7_sol_chip_2_Template_sol_chip_closed_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r30);
      const index_r28 = restoredCtx.index;
      const ctx_r29 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r29.removeItem(index_r28));
    })("closeButtonKeydown", function TagFilterTypeComponent_div_7_sol_chip_2_Template_sol_chip_closeButtonKeydown_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r30);
      const index_r28 = restoredCtx.index;
      const ctx_r31 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r31.onCloseButtonKeydown($event, index_r28));
    })("keydown", function TagFilterTypeComponent_div_7_sol_chip_2_Template_sol_chip_keydown_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r30);
      const index_r28 = restoredCtx.index;
      const ctx_r32 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r32.onChipKeydown($event, index_r28));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const chip_r27 = ctx.$implicit;
    const index_r28 = ctx.index;
    i0.ɵɵproperty("allowClose", true)("label", chip_r27.label)("size", "medium")("errorState", !chip_r27.isValid)("chipTabIndex", index_r28 == 0 ? "0" : "-1");
  }
}
function TagFilterTypeComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29, 30);
    i0.ɵɵtemplate(2, TagFilterTypeComponent_div_7_sol_chip_2_Template, 1, 5, "sol-chip", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.tags);
  }
}
function TagFilterTypeComponent_div_10_1_ng_template_0_Template(rf, ctx) {}
function TagFilterTypeComponent_div_10_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TagFilterTypeComponent_div_10_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TagFilterTypeComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, TagFilterTypeComponent_div_10_1_Template, 1, 0, null, 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const _r12 = i0.ɵɵreference(29);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r12);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r5.queryTagInputTextLimitWarning, " ");
  }
}
function TagFilterTypeComponent_12_ng_template_0_Template(rf, ctx) {}
function TagFilterTypeComponent_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TagFilterTypeComponent_12_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TagFilterTypeComponent_15_ng_template_0_Template(rf, ctx) {}
function TagFilterTypeComponent_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TagFilterTypeComponent_15_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TagFilterTypeComponent_18_ng_template_0_Template(rf, ctx) {}
function TagFilterTypeComponent_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TagFilterTypeComponent_18_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TagFilterTypeComponent_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 34);
    i0.ɵɵelement(1, "path", 35)(2, "path", 36)(3, "path", 37);
    i0.ɵɵelementEnd();
  }
}
function TagFilterTypeComponent_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 34);
    i0.ɵɵelement(1, "path", 38)(2, "path", 39)(3, "path", 40);
    i0.ɵɵelementEnd();
  }
}
const _c6 = a0 => ({
  visible: a0
});
const _c7 = ["slider"];
function RangeSliderFilterType_Conditional_1_ng_template_3_Template(rf, ctx) {}
function RangeSliderFilterType_Conditional_1_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.msgInvalidConfig);
  }
}
function RangeSliderFilterType_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-tabs", 2);
    i0.ɵɵlistener("selectedTabChange", function RangeSliderFilterType_Conditional_1_Template_sol_tabs_selectedTabChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.selectedTab($event));
    });
    i0.ɵɵelementStart(1, "sol-tab", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, RangeSliderFilterType_Conditional_1_ng_template_3_Template, 0, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(5, RangeSliderFilterType_Conditional_1_p_5_Template, 2, 1, "p", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "sol-tab", 7)(7, "div", 8)(8, "div", 9)(9, "sol-time-duration", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function RangeSliderFilterType_Conditional_1_Template_sol_time_duration_ngModelChange_9_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r7 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r7.start, $event) || (ctx_r7.start = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("focusout", function RangeSliderFilterType_Conditional_1_Template_sol_time_duration_focusout_9_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.updateRangeSliderStart());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵelement(11, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 9)(13, "sol-time-duration", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function RangeSliderFilterType_Conditional_1_Template_sol_time_duration_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r9 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r9.end, $event) || (ctx_r9.end = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("focusout", function RangeSliderFilterType_Conditional_1_Template_sol_time_duration_focusout_13_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.updateRangeSliderEnd());
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("isActive", ctx_r0.activeTabIndex === 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.msgInvalidConfig);
    i0.ɵɵadvance();
    i0.ɵɵproperty("isActive", ctx_r0.activeTabIndex === 1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("labelText", "FROM");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.start);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("labelText", "TO");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.end);
  }
}
function RangeSliderFilterType_Conditional_2_ng_template_1_Template(rf, ctx) {}
function RangeSliderFilterType_Conditional_2_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r13.msgInvalidConfig);
  }
}
function RangeSliderFilterType_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, RangeSliderFilterType_Conditional_2_ng_template_1_Template, 0, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(3, RangeSliderFilterType_Conditional_2_p_3_Template, 2, 1, "p", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.msgInvalidConfig);
  }
}
function SelectFilterTypeComponent_sol_select_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-select", 3);
    i0.ɵɵlistener("selectionChange", function SelectFilterTypeComponent_sol_select_1_Template_sol_select_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.selectionChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("selection", ctx_r0.selection)("options", ctx_r0.filterConfig.options)("isMultiple", ctx_r0.filterConfig.isMultiple)("optionsLabel", ctx_r0.filterConfig.optionsLabel)("optionsValue", ctx_r0.filterConfig.optionsValue)("searchEnabled", ctx_r0.filterConfig.searchEnabled)("isReadOnly", ctx_r0.readOnly)("projectedContent", _r2);
  }
}
function SelectFilterTypeComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-svg-sprite-icon", 4);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const optionScope_r5 = ctx.optionScope;
    i0.ɵɵproperty("iconName", optionScope_r5.projectedData.iconName)("spritePath", optionScope_r5.projectedData.spritePath)("wrapperClass", "select-filter-icon")("ariaLabel", optionScope_r5.ariaLabel)("ariaHidden", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(optionScope_r5.displayText);
  }
}
function DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-date-range-wrapper", 1);
    i0.ɵɵlistener("closed", function DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template_sol_date_range_wrapper_closed_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closed($event));
    })("dateSelected", function DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template_sol_date_range_wrapper_dateSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.dateSelected($event));
    })("listSelected", function DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template_sol_date_range_wrapper_listSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.changeSelectedDate($event));
    })("selectedMonth", function DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template_sol_date_range_wrapper_selectedMonth_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.changeMonth($event));
    })("numericSelctorOutput", function DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template_sol_date_range_wrapper_numericSelctorOutput_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.selectNumRange($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template_sol_date_range_wrapper_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r7 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r7.selectedDateRange, $event) || (ctx_r7.selectedDateRange = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("startingDay", ctx_r0.dateRangeWrapperConfig.startingDay)("min", ctx_r0.dateRangeWrapperConfig.min)("max", ctx_r0.dateRangeWrapperConfig.max)("specialDates", ctx_r0.dateRangeWrapperConfig.specialDates)("displayleftPanel", ctx_r0.displayLeftPanel)("showTime", ctx_r0.showTime)("type", "range-selection")("mode", "inline")("overlayState", false);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.selectedDateRange);
  }
}
const _c8 = ["menuTrigger"];
function QueryBuilderComponent_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "sol-query-chip", 9);
    i0.ɵɵlistener("chipValueChanged", function QueryBuilderComponent_ng_container_1_div_1_Template_sol_query_chip_chipValueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r7 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r7.onChipValueChanged($event));
    })("chipRemoved", function QueryBuilderComponent_ng_container_1_div_1_Template_sol_query_chip_chipRemoved_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r9 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r9.removeFilterFromQuery($event));
    })("onTouch", function QueryBuilderComponent_ng_container_1_div_1_Template_sol_query_chip_onTouch_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r10 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r10.onQueryChipTouch());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedFilter_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("definition", ctx_r5.filtersByIdMap.get(selectedFilter_r6.filterId))("value", selectedFilter_r6.value)("operator", selectedFilter_r6.operator);
  }
}
function QueryBuilderComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, QueryBuilderComponent_ng_container_1_div_1_Template, 2, 3, "div", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.model.selection)("ngForTrackBy", ctx_r0.chipTrackBy);
  }
}
function QueryBuilderComponent_sol_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-button", 10, 11);
    i0.ɵɵlistener("onClick", function QueryBuilderComponent_sol_button_2_Template_sol_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.updateMenuFilters());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 12);
    i0.ɵɵelement(3, "path", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(6);
    i0.ɵɵproperty("matMenuTriggerFor", _r3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.addFilterText, " ");
  }
}
function QueryBuilderComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("fixed", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.errorMessageText);
  }
}
function QueryBuilderComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function QueryBuilderComponent_button_7_Template_button_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r16);
      const filter_r14 = restoredCtx.$implicit;
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.addFilterToQuery(filter_r14));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r14 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", filter_r14.filterName, " ");
  }
}
function DemoFilterTypeComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 4);
    i0.ɵɵlistener("click", function DemoFilterTypeComponent_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clickButton(ctx_r3.filterConfig.btn1));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.filterConfig.btn1);
  }
}
function DemoFilterTypeComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 4);
    i0.ɵɵlistener("click", function DemoFilterTypeComponent_div_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.clickButton(ctx_r5.filterConfig.btn2));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.filterConfig.btn2);
  }
}
function DemoFilterTypeComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function DemoFilterTypeComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r7 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r7.clickButton(undefined));
    });
    i0.ɵɵtext(1, " \xD7 ");
    i0.ɵɵelementEnd();
  }
}
function TestDisplayFilterTypeComponent_ul_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.updateValue(0));
    });
    i0.ɵɵtext(3, "Single Number (0)");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_1_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.updateValue(20));
    });
    i0.ɵɵtext(6, "Single Number (20)");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "li")(8, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_1_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.updateValue([42]));
    });
    i0.ɵɵtext(9, "Array of 1 Number");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "li")(11, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_1_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.updateValue([42, 43]));
    });
    i0.ɵɵtext(12, "Array of 2 Numbers");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "li")(14, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_1_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.updateValue({
        start: 48,
        end: 120
      }));
    });
    i0.ɵɵtext(15, "Range of Numbers");
    i0.ɵɵelementEnd()()();
  }
}
function TestDisplayFilterTypeComponent_ul_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_2_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.updateValue("Blue"));
    });
    i0.ɵɵtext(3, "Single String");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_2_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.updateValue(["Purple"]));
    });
    i0.ɵɵtext(6, "Array of 1 String");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "li")(8, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_2_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.updateValue(["Blue", "Red"]));
    });
    i0.ɵɵtext(9, "Array of 2 Strings");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "li")(11, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_2_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.updateValue([]));
    });
    i0.ɵɵtext(12, "Empty Array");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "li")(14, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_2_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.updateValue(null));
    });
    i0.ɵɵtext(15, "Null");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "li")(17, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_2_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.updateValue(undefined));
    });
    i0.ɵɵtext(18, "Undefined");
    i0.ɵɵelementEnd()()();
  }
}
function TestDisplayFilterTypeComponent_ul_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_3_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.updateValue(ctx_r19.filterConfig.options[0][ctx_r19.filterConfig.optionsValue]));
    });
    i0.ɵɵtext(3, "Single Lookup");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_3_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.updateValue([ctx_r21.filterConfig.options[ctx_r21.filterConfig.options.length - 1][ctx_r21.filterConfig.optionsValue]]));
    });
    i0.ɵɵtext(6, "Array of 1 Lookup");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "li")(8, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_3_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.updateValue([ctx_r22.filterConfig.options[0][ctx_r22.filterConfig.optionsValue], ctx_r22.filterConfig.options[ctx_r22.filterConfig.options.length - 1][ctx_r22.filterConfig.optionsValue]]));
    });
    i0.ɵɵtext(9, " Array of 2 Lookups ");
    i0.ɵɵelementEnd()()();
  }
}
function TestDisplayFilterTypeComponent_ul_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_4_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.updateValue({
        id: 1,
        description: "Gryffindor",
        color: "Red"
      }));
    });
    i0.ɵɵtext(3, "Single Object");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_4_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.updateValue([{
        id: 2,
        description: "Ravenclaw",
        color: "Blue"
      }]));
    });
    i0.ɵɵtext(6, "Array of 1 Object");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "li")(8, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_4_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.updateValue([{
        id: 3,
        description: "Hufflepuff",
        color: "Yellow"
      }, {
        id: 4,
        description: "Slytherin",
        color: "Green"
      }]));
    });
    i0.ɵɵtext(9, " Array of 2 Objects ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "li")(11, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_4_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.updateValue({
        id: 1,
        name: "Hogwarts"
      }));
    });
    i0.ɵɵtext(12, "Object Missing Property");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "li")(14, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_4_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.updateValue([]));
    });
    i0.ɵɵtext(15, "Empty Array");
    i0.ɵɵelementEnd()()();
  }
}
function TestDisplayFilterTypeComponent_ul_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.updateValue(0));
    });
    i0.ɵɵtext(3, "0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.updateValue(5));
    });
    i0.ɵɵtext(6, "5");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "li")(8, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r32 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r32.updateValue(150));
    });
    i0.ɵɵtext(9, "150");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "li")(11, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.updateValue(6000));
    });
    i0.ɵɵtext(12, "6000");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "li")(14, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r34 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r34.updateValue(82800));
    });
    i0.ɵɵtext(15, "82800");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "li")(17, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r35 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r35.updateValue([6000]));
    });
    i0.ɵɵtext(18, "Array of 1 number");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "li")(20, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_20_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r36 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r36.updateValue([1000, 2000, 3000, 4000, 5000]));
    });
    i0.ɵɵtext(21, "Array of 5 numbers");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "li")(23, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_5_Template_button_click_23_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r37 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r37.updateValue({
        start: 600,
        end: 3600
      }));
    });
    i0.ɵɵtext(24, "Range");
    i0.ɵɵelementEnd()()();
  }
}
function TestDisplayFilterTypeComponent_ul_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_6_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r38 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r38.updateValue(ctx_r38.dateSingle));
    });
    i0.ɵɵtext(3, "Single Date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_6_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r40 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r40.updateValue(ctx_r40.dateRange));
    });
    i0.ɵɵtext(6, "Range of Dates");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "li")(8, "button", 3);
    i0.ɵɵlistener("click", function TestDisplayFilterTypeComponent_ul_6_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r41 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r41.updateValue(undefined));
    });
    i0.ɵɵtext(9, "Undefined");
    i0.ɵɵelementEnd()()();
  }
}
var CloseOverlayEventType;
(function (CloseOverlayEventType) {
  CloseOverlayEventType[CloseOverlayEventType["ESCAPE_KEY"] = 0] = "ESCAPE_KEY";
  CloseOverlayEventType[CloseOverlayEventType["BACKDROP_CLICK"] = 1] = "BACKDROP_CLICK";
  CloseOverlayEventType[CloseOverlayEventType["FILTER_CLICK"] = 2] = "FILTER_CLICK";
})(CloseOverlayEventType || (CloseOverlayEventType = {}));
class QueryChipOverlayRefService {
  constructor(overlayRef) {
    this.overlayRef = overlayRef;
    this.popoverClosedSubject$ = new Subject();
    this.selectionChangedSubject$ = new Subject();
    this.metadataChangedSubject$ = new Subject();
    // 'Escape' key closes the overlay
    this.keydownEventsSubscription = this.overlayRef.keydownEvents().pipe(filter(event => event.key === 'Escape')).subscribe(() => {
      this.close(CloseOverlayEventType.ESCAPE_KEY);
    });
    // Backdrop-overlay click will close the overlay
    this.outsidePointerEventsSubscription = this.overlayRef.backdropClick().subscribe(() => {
      this.close(CloseOverlayEventType.BACKDROP_CLICK);
    });
  }
  // Close the overlay
  close(type) {
    // the filter type parent class can execute code right before the overlay is closed by defining onOverlayClose()
    if (this.onOverlayClose && typeof this.onOverlayClose === 'function') {
      this.onOverlayClose();
    }
    this.overlayRef.dispose();
    if (Array.isArray(this.currentSelection) && this.currentSelection.length === 0) {
      this.currentSelection = undefined;
    }
    this.selectionChangedSubject$.next(this.currentSelection);
    this.metadataChangedSubject$.next(this.currentMetadata);
    this.popoverClosedSubject$.next(type);
    this.popoverClosedSubject$.complete();
  }
  // An observable which can subscribed to when the overlay is closed
  overlayClosed() {
    return this.popoverClosedSubject$.asObservable();
  }
  // method the filter type parent class calls when the selected value of the filter type editor has changed
  updateValue(value) {
    this.currentSelection = value;
  }
  // method the filter type parent class calls right before the overlay is closed
  updateMetadata(value) {
    this.currentMetadata = value;
  }
  // an observable which can subscribed to when the selected value of the filter type editor has changed
  selectionChanged() {
    return this.selectionChangedSubject$.asObservable();
  }
  // an observable which can subscribed to when the metadata of the filter type editor has changed
  metadataChanged() {
    return this.metadataChangedSubject$.asObservable();
  }
  ngOnDestroy() {
    this.keydownEventsSubscription?.unsubscribe();
    this.outsidePointerEventsSubscription?.unsubscribe();
  }
  static {
    this.ɵfac = function QueryChipOverlayRefService_Factory(t) {
      return new (t || QueryChipOverlayRefService)(i0.ɵɵinject(i1.OverlayRef));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: QueryChipOverlayRefService,
      factory: QueryChipOverlayRefService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QueryChipOverlayRefService, [{
    type: Injectable
  }], () => [{
    type: i1.OverlayRef
  }], null);
})();
class QueryChipOverlayComponent {
  constructor() {
    this.theEditorHasAFocusableElementOfItsOwn = false; // assume the editor has no focusable item
  }
  ngOnInit() {
    setTimeout(() => {
      // The overlay needs a focusable item present when the overlay first opens for the keyboard navigation
      // to work properly and focus to be trapped inside the overlay. We have an empty div that will get the
      // focus, if there is no other element to get it. (With the range slider editor, for example, there
      // is a brief delay before the slider handles load.) After a brief delay, we check whether or not there
      // are any other focusable elements. If there's at least one, we make the empty div unfocusable; if the
      // unfocusable empty div has focus, we move the focus to the first new focusable element.
      const focusableEls = [...this.overlayContent.nativeElement.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"]):not(.empty-div-to-trap-focus)')].filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
      if (focusableEls.length && focusableEls.length > 0) {
        this.theEditorHasAFocusableElementOfItsOwn = true;
        if (document.activeElement?.className.includes('empty-div-to-trap-focus')) {
          focusableEls[0].focus();
        }
      }
    }, 100);
  }
  attachComponentPortal(componentPortal) {
    this.selectedPortal = componentPortal;
  }
  static {
    this.ɵfac = function QueryChipOverlayComponent_Factory(t) {
      return new (t || QueryChipOverlayComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: QueryChipOverlayComponent,
      selectors: [["sol-query-chip-overlay"]],
      viewQuery: function QueryChipOverlayComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlayContent = _t.first);
        }
      },
      decls: 4,
      vars: 3,
      consts: [["role", "region", "cdkTrapFocus", "", 1, "overlay-content", 3, "cdkTrapFocusAutoCapture"], ["overlayContent", ""], [3, "cdkPortalOutlet"], [1, "empty-div-to-trap-focus", 3, "tabindex"]],
      template: function QueryChipOverlayComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0, 1);
          i0.ɵɵtemplate(2, QueryChipOverlayComponent_ng_template_2_Template, 0, 0, "ng-template", 2);
          i0.ɵɵelement(3, "div", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cdkTrapFocusAutoCapture", true);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cdkPortalOutlet", ctx.selectedPortal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("tabindex", ctx.theEditorHasAFocusableElementOfItsOwn ? -1 : 0);
        }
      },
      dependencies: [i1$1.CdkTrapFocus, i2.CdkPortalOutlet],
      styles: ["[_nghost-%COMP%]{position:relative;margin:.25rem 0 .25rem -.5rem;padding:0;border-radius:var(--radii-small-allcorners);border:1px solid var(--color-globalstate-active-border);background:#fff;box-shadow:0 1px 2px #00000052;font-family:var(--typography-opensans-body-body1-font-family);font-size:var(--typography-opensans-body1-font-size);overflow-x:auto}.overlay-content[_ngcontent-%COMP%]{max-width:37.5rem;min-width:9.375rem}.empty-div-to-trap-focus[_ngcontent-%COMP%]{width:9rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QueryChipOverlayComponent, [{
    type: Component,
    args: [{
      selector: 'sol-query-chip-overlay',
      template: "<div class=\"overlay-content\" role=\"region\" #overlayContent cdkTrapFocus [cdkTrapFocusAutoCapture]=\"true\">\n  <ng-template [cdkPortalOutlet]=\"selectedPortal\"></ng-template>\n  <div class=\"empty-div-to-trap-focus\" [tabindex]=\"theEditorHasAFocusableElementOfItsOwn ? -1 : 0\"></div>\n</div>\n",
      styles: [":host{position:relative;margin:.25rem 0 .25rem -.5rem;padding:0;border-radius:var(--radii-small-allcorners);border:1px solid var(--color-globalstate-active-border);background:#fff;box-shadow:0 1px 2px #00000052;font-family:var(--typography-opensans-body-body1-font-family);font-size:var(--typography-opensans-body1-font-size);overflow-x:auto}.overlay-content{max-width:37.5rem;min-width:9.375rem}.empty-div-to-trap-focus{width:9rem}\n"]
    }]
  }], () => [], {
    overlayContent: [{
      type: ViewChild,
      args: ['overlayContent']
    }]
  });
})();
const FILTER_COMPONENT_INJECTED_DATA = new InjectionToken('FILTER_COMPONENT_INJECTED_DATA');
// We define numerous possible posititions for the overlay in relation to the target. The CDK will try to
// position the overlay in each one in order until it finds a position where the entire overlay is visible.
const OVERLAY_POSITIONS = [{
  originX: 'start',
  overlayX: 'start',
  originY: 'bottom',
  overlayY: 'top'
}, {
  originX: 'end',
  overlayX: 'end',
  originY: 'bottom',
  overlayY: 'top'
}, {
  originX: 'start',
  overlayX: 'start',
  originY: 'top',
  overlayY: 'bottom'
}, {
  originX: 'end',
  overlayX: 'end',
  originY: 'top',
  overlayY: 'bottom'
} // Fourth, try above and right-aligned with the target.
];
for (let offsetX = -50; offsetX > -400; offsetX = offsetX - 50) {
  OVERLAY_POSITIONS.push({
    originX: 'start',
    overlayX: 'start',
    offsetX: offsetX,
    originY: 'bottom',
    overlayY: 'top'
  }); // Next, try below and left-aligned with offset from the target.
  OVERLAY_POSITIONS.push({
    originX: 'start',
    overlayX: 'start',
    offsetX: offsetX,
    originY: 'top',
    overlayY: 'bottom'
  }); // Next, try above and left-aligned with offset from the target.
}
class QueryChipOverlayService {
  constructor(overlay, injector) {
    this.overlay = overlay;
    this.injector = injector;
  }
  open(component, target, config = {}) {
    // Define the position strategy
    const positionStrategy = this.overlay.position().flexibleConnectedTo(target).withPositions(OVERLAY_POSITIONS).withLockedPosition(true) // This ensures the position remains fixed
    .withPush(false); // This is the line that prevents the overlay from being pushed into view
    // Create the overlay with the position strategy
    const overlayConfig = new OverlayConfig({
      positionStrategy: positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close(),
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop'
    });
    const overlayTmplRef = this.overlay.create(overlayConfig);
    const overlayRef = new QueryChipOverlayRefService(overlayTmplRef);
    const portalInjector = Injector.create({
      parent: this.injector,
      providers: [{
        provide: FILTER_COMPONENT_INJECTED_DATA,
        useValue: Object.assign({}, config)
      }, {
        provide: QueryChipOverlayRefService,
        useValue: overlayRef
      }]
    });
    const popover = overlayTmplRef.attach(new ComponentPortal(QueryChipOverlayComponent, null, portalInjector)).instance;
    popover.attachComponentPortal(new ComponentPortal(component, null, portalInjector));
    return overlayRef;
  }
  static {
    this.ɵfac = function QueryChipOverlayService_Factory(t) {
      return new (t || QueryChipOverlayService)(i0.ɵɵinject(i1.Overlay), i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: QueryChipOverlayService,
      factory: QueryChipOverlayService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QueryChipOverlayService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Overlay
  }, {
    type: i0.Injector
  }], null);
})();
class FilterTypeRegistryService {
  constructor() {
    this._registry = [];
  }
  getAll() {
    return this._registry;
  }
  getByName(name) {
    return this._registry.find(filterType => filterType.name === name);
  }
  add(filterType) {
    if (!this.getByName(filterType.name)) {
      this._registry.push(filterType);
    }
  }
  static {
    this.ɵfac = function FilterTypeRegistryService_Factory(t) {
      return new (t || FilterTypeRegistryService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FilterTypeRegistryService,
      factory: FilterTypeRegistryService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterTypeRegistryService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class QueryChipComponent {
  constructor(ngZone, elementRef, translationService, filterTypeRegistry, queryChipOverlayService) {
    this.ngZone = ngZone;
    this.elementRef = elementRef;
    this.translationService = translationService;
    this.filterTypeRegistry = filterTypeRegistry;
    this.queryChipOverlayService = queryChipOverlayService;
    this.overlayOpen = false;
    this.operatorOverlayOpen = false;
    this.focusWithinChip = false;
    this.currentSelectionDisplay = '';
    this.touched = false;
    this.invalidValues = [undefined, null];
    this.canOverlayOpen = true;
    this.currentOperatorSelectionDisplay = '';
    /**
     * event to be triggered when a chip is removed
     */
    this.chipRemoved = new EventEmitter();
    this.chipValueChanged = new EventEmitter();
    this.onTouch = new EventEmitter();
  }
  isValid() {
    return this.invalidValues.includes(this.value) || Array.isArray(this.value) && this.value.length === 0 ? !this.touched : true;
  }
  isEmpty() {
    return !this.currentSelectionDisplay && this.touched;
  }
  enterChipOnEnterOrSpace($event) {
    if (($event.code === 'Enter' || $event.code === 'Space') && this.canOverlayOpen) {
      this.enterChip($event);
    }
  }
  showOverlayOnEnterOrSpace($event) {
    if (($event.code === 'Enter' || $event.code === 'Space') && this.canOverlayOpen) {
      this.showOverlay();
    }
  }
  showOperatorOverlayOnEnterOrSpace($event) {
    if (($event.code === 'Enter' || $event.code === 'Space') && this.canOverlayOpen) {
      this.showOperatorOverlay();
    }
  }
  showOperatorOverlayOnClick() {
    if (this.canOverlayOpen) {
      this.showOperatorOverlay();
    }
  }
  showOverlayOnClick() {
    if (this.canOverlayOpen) {
      this.showOverlay();
    }
  }
  showOverlay() {
    const filterType = this.filterTypeRegistry.getByName(this.definition.filterType);
    if (this.overlayTrigger && filterType && filterType.component) {
      this.overlayRef = this.queryChipOverlayService.open(filterType.component, this.overlayTrigger, {
        selection: this.currentSelection,
        filterConfig: this.definition.filterConfig,
        metadata: this.currentMetadata,
        readOnly: this.definition.readOnly
      });
      this.overlayOpen = true;
      this.focusWithinChip = true;
      this.selectionChangedSubscription = this.overlayRef.selectionChanged().subscribe(value => {
        this.currentSelection = value;
        this.currentSelectionDisplay = this.setCurrentSelectionDisplay(value);
      });
      this.metadataChangedSubscription = this.overlayRef.metadataChanged().subscribe(value => {
        this.currentMetadata = value;
      });
      this.overlayClosedSubscription = this.overlayRef.overlayClosed().subscribe(type => {
        this.overlayOpen = false;
        if (this.currentSelection !== this.value) {
          this.value = this.currentSelection;
          const change = {
            filterId: this.definition.filterId,
            value: this.value,
            operator: this.operator
          };
          this.chipValueChanged.emit(change);
        }
        if (!this.touched) {
          this.touched = true;
          this.onTouch.emit();
        }
        if (this.definition.operatorConfig?.options && this.definition.operatorConfig?.options.length > 0) {
          this.setFocusOnSecondFocusableItem();
        } else {
          this.setFocusOnFirstFocusableItem();
        }
      });
    }
  }
  showOperatorOverlay() {
    const operatorSelect = this.filterTypeRegistry.getByName('select');
    this.overlayRef = this.queryChipOverlayService.open(operatorSelect?.component, this.overlayOperatorTrigger, {
      selection: this.currentOperatorSelection,
      filterConfig: {
        isMultiple: false,
        searchEnabled: false,
        optionsLabel: this.definition.operatorConfig?.optionsLabel,
        optionsValue: this.definition.operatorConfig?.optionsValue,
        options: this.definition.operatorConfig?.options
      },
      metadata: this.currentOperatorMetadata
    });
    this.operatorOverlayOpen = true;
    this.focusWithinChip = true;
    this.selectionOperatorChangedSubscription = this.overlayRef.selectionChanged().subscribe(value => {
      this.currentOperatorSelection = value;
      this.currentOperatorSelectionDisplay = this.setCurrentOperatorSelectionDisplay(value);
    });
    this.operatorMetadataChangedSubscription = this.overlayRef.metadataChanged().subscribe(value => {
      this.currentOperatorMetadata = value;
    });
    this.overlayOperatorClosedSubscription = this.overlayRef.overlayClosed().subscribe(type => {
      this.operatorOverlayOpen = false;
      if (this.currentOperatorSelection) {
        this.operator = this.currentOperatorSelection;
        const change = {
          filterId: this.definition.filterId,
          value: this.value,
          operator: this.currentOperatorSelection
        };
        this.chipValueChanged.emit(change);
      }
      if (!this.touched) {
        this.touched = true;
        this.onTouch.emit();
      }
    });
  }
  ngOnInit() {
    if (this.value !== undefined) {
      this.currentSelection = this.value;
      this.currentSelectionDisplay = this.setCurrentSelectionDisplay(this.value);
    }
    // Update the overlay open ability based on the filter type
    this.updateOverlayOpenAbility();
    if (this.operator !== undefined) {
      this.currentOperatorSelection = this.operator;
      this.currentOperatorSelectionDisplay = this.setCurrentOperatorSelectionDisplay(this.operator);
    } else if (this.definition && this.definition.operatorConfig && this.definition.operatorConfig.options) {
      this.currentOperatorSelection = this.definition.operatorConfig.options[0].operatorId;
      this.currentOperatorSelectionDisplay = this.setCurrentOperatorSelectionDisplay(this.definition.operatorConfig.options[0].operatorId);
    }
    this.ngZone.runOutsideAngular(() => {
      // Click outside when the overlay is OFF to set the currect chip style
      this.windowClickEventSubscription = fromEvent(window, 'click', {
        capture: true
      }).subscribe(event => {
        if (!this.overlayOpen && !this.operatorOverlayOpen && this.focusWithinChip && !this.elementRef.nativeElement.contains(event.target)) {
          this.ngZone.run(() => {
            this.focusWithinChip = false;
          });
        }
      });
    });
  }
  updateOverlayOpenAbility() {
    const filterType = this.filterTypeRegistry.getByName(this.definition.filterType);
    if (this.definition?.readOnly) {
      if (filterType?.component.supportsReadOnly && Array.isArray(this.value) && this.value.length > 1) {
        this.canOverlayOpen = true;
      } else {
        this.canOverlayOpen = false;
      }
    }
  }
  removeChipOnEnterOrSpace($event) {
    if ($event.code === 'Enter' || $event.code === 'Space') {
      this.removeChip();
    }
  }
  removeChip() {
    this.chipRemoved.emit(this.definition.filterId);
  }
  enterChip($event) {
    if (!this.overlayOpen && !this.operatorOverlayOpen) {
      $event.stopPropagation();
      $event.preventDefault();
      if (this.definition?.operatorConfig?.options && this.definition?.operatorConfig?.options.length > 0) {
        this.setFocusOnSecondFocusableItem();
      } else {
        this.setFocusOnFirstFocusableItem();
      }
    }
  }
  exitChip($event) {
    $event.stopPropagation();
    $event.preventDefault();
    this.focusWithinChip = false;
    this.removeFocusWithinChip();
    this.elementRef.nativeElement.querySelectorAll('.sol-query-chip')[0].focus();
  }
  /**
   * Called when the user presses the left or right arrow keys while the focus is on the chip
   */
  moveFocusWithinChip($event) {
    $event.stopPropagation();
    $event.preventDefault();
    if (this.focusWithinChip) {
      const focusableItems = this.elementRef.nativeElement.querySelectorAll('.focusable-item');
      let activeIndex = -1;
      if (focusableItems && focusableItems.length) {
        focusableItems.forEach((focusableItem, index) => {
          if (focusableItem === document.activeElement) {
            activeIndex = index;
          }
        });
      }
      if ($event.code === 'ArrowRight') {
        activeIndex = activeIndex + 1;
      } else if ($event.code === 'ArrowLeft') {
        activeIndex = activeIndex - 1;
      }
      activeIndex = activeIndex < 0 ? 0 : activeIndex;
      if (activeIndex < focusableItems.length) {
        focusableItems[activeIndex].focus();
      }
    }
  }
  moveFocusOutsideChip() {
    this.overlayOpen = false;
    this.operatorOverlayOpen = false;
    this.focusWithinChip = false;
    this.removeFocusWithinChip();
  }
  setCurrentOperatorSelectionDisplay(value) {
    if (this.definition && this.definition.operatorConfig && this.definition.operatorConfig.options) {
      const operatorObject = this.definition.operatorConfig.options.find(x => x.operatorId === value);
      return operatorObject?.operatorName;
    }
  }
  setFocusOnFirstFocusableItem() {
    this.focusWithinChip = true;
    const focusableItems = this.elementRef.nativeElement.querySelectorAll('.focusable-item');
    if (focusableItems && focusableItems.length) {
      focusableItems[0].focus();
    }
  }
  setFocusOnSecondFocusableItem() {
    this.focusWithinChip = true;
    const focusableItems = this.elementRef.nativeElement.querySelectorAll('.focusable-item');
    if (focusableItems && focusableItems.length) {
      focusableItems[1]?.focus();
    }
  }
  removeFocusWithinChip() {
    const focusableItems = this.elementRef.nativeElement.querySelectorAll('.focusable-item');
    if (focusableItems && focusableItems.length) {
      focusableItems.forEach(focusableItem => {
        focusableItem.blur();
      });
    }
  }
  setCurrentSelectionDisplay(value) {
    /* -- Use customFormatFullFn, if provided -- */
    if (this.definition && this.definition.filterConfig && this.definition.filterConfig.customFormatFullFn) {
      return this.definition.filterConfig.customFormatFullFn(value);
    }
    /* Split Value Into Individual Values, if necessary */
    // --------
    // By Default: Format the Value as One Unit
    const valuesToFormat = [value];
    // For Ranges: Format Start and End Values Separately
    if (value && value.start !== undefined && value.end !== undefined) {
      valuesToFormat[0] = value.start;
      valuesToFormat[1] = value.end;
    }
    // For Non-Empty Arrays: Format 1st Element
    // For Empty Arrays: Format Nothing
    if (Array.isArray(value)) {
      if (value.length > 0) {
        valuesToFormat[0] = value[0];
      } else {
        valuesToFormat.splice(0);
      }
    }
    /* Format the Individual Values -- */
    // --------
    const valuesFormatted = this.formatValues(valuesToFormat);
    /* Combine Individual Values into Single String */
    // --------
    // Ranges: Return Two Values Combined with a Dash
    if (value && value.start !== undefined && value.end !== undefined) {
      return valuesFormatted[0] + ' – ' + valuesFormatted[1];
    }
    // Arrays: Return 1st Value or '# Selected'
    if (Array.isArray(value)) {
      if (value.length === 1) {
        return valuesFormatted[0];
      } else {
        return this.translationService.getTranslation('numberSelectedText', value.length);
      }
    }
    // By Default: Return Single Value
    return valuesFormatted[0];
  }
  formatValues(valuesToFormat) {
    const formattedValues = [];
    if (valuesToFormat) {
      for (let i = 0; i < valuesToFormat.length; i++) {
        // by default, display the raw value as a string
        formattedValues[i] = valuesToFormat[i];
        if (valuesToFormat[i] !== undefined && valuesToFormat[i] !== null) {
          formattedValues[i] = String(valuesToFormat[i]);
        }
        /* customFormatFn */
        if (this.definition && this.definition.filterConfig && this.definition.filterConfig.customFormatFn) {
          formattedValues[i] = this.definition.filterConfig.customFormatFn(valuesToFormat[i]);
        }
        // Lookup
        else if (this.definition && this.definition.filterConfig && this.definition.filterConfig.optionsLabel && this.definition.filterConfig.optionsValue && this.definition.filterConfig.options && this.definition.filterConfig.options.length) {
          const foundOption = this.definition.filterConfig.options.find(option => option[this.definition.filterConfig.optionsValue] === valuesToFormat[i]);
          if (foundOption) {
            formattedValues[i] = foundOption[this.definition.filterConfig.optionsLabel];
          }
        }
        // Object
        else if (this.definition && this.definition.filterConfig && this.definition.filterConfig.objectLabel) {
          if (valuesToFormat[i] !== undefined && valuesToFormat[i][this.definition.filterConfig.objectLabel] !== undefined) {
            formattedValues[i] = valuesToFormat[i][this.definition.filterConfig.objectLabel];
          }
        }
        // Date
        else if (valuesToFormat[i] instanceof Date) {
          formattedValues[i] = this.datePipeCasting(valuesToFormat[i], navigator.language, this.definition?.filterConfig?.dateFormat);
        }
      }
    }
    return formattedValues;
  }
  datePipeCasting(date, language, dateFormat) {
    try {
      const datePipe = new DatePipe(language);
      console.log('in try -  this is  date pipe after set language' + datePipe);
      return datePipe.transform(date, dateFormat);
    } catch {
      const datePipeFallback = new DatePipe('en-US');
      console.log('in catch this is  date pipe after set language' + datePipeFallback);
      return datePipeFallback.transform(date, dateFormat);
    }
  }
  ngOnDestroy() {
    this.overlayClosedSubscription?.unsubscribe();
    this.selectionChangedSubscription?.unsubscribe();
    this.windowClickEventSubscription?.unsubscribe();
    this.metadataChangedSubscription?.unsubscribe();
  }
  static {
    this.ɵfac = function QueryChipComponent_Factory(t) {
      return new (t || QueryChipComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.TranslationService), i0.ɵɵdirectiveInject(FilterTypeRegistryService), i0.ɵɵdirectiveInject(QueryChipOverlayService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: QueryChipComponent,
      selectors: [["sol-query-chip"]],
      viewQuery: function QueryChipComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlayTrigger = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlayOperatorTrigger = _t.first);
        }
      },
      inputs: {
        definition: "definition",
        value: "value",
        operator: "operator"
      },
      outputs: {
        chipRemoved: "chipRemoved",
        chipValueChanged: "chipValueChanged",
        onTouch: "onTouch"
      },
      features: [i0.ɵɵProvidersFeature([QueryChipOverlayService, QueryChipOverlayRefService])],
      decls: 13,
      vars: 29,
      consts: [["tabindex", "0", 1, "sol-query-chip", 3, "keypress", "keydown.escape", "keydown.arrowRight", "keydown.arrowLeft", "keydown.arrowDown", "keydown.arrowUp", "keydown.tab", "keydown.shift.tab"], [1, "chip-filter-name", 3, "ngClass"], ["class", "invalid-icon", 4, "ngIf"], ["solTooltip", "", 1, "truncate", 3, "trigger", "overflowTooltip", "position", "darkMode", "interactive", "content", "arrow"], ["tabIndex", "-1", "class", "chip-filter-content focusable-item", 3, "ngClass", "click", "keypress", 4, "ngIf"], ["tabIndex", "-1", 1, "chip-filter-content", "focusable-item", 3, "ngClass", "click", "keypress"], [1, "chip-value-btn"], ["overlayTrigger", ""], ["solTooltip", "", 3, "trigger", "overflowTooltip", "position", "darkMode", "interactive", "content", "arrow", 4, "ngIf"], [4, "ngIf"], ["class", "close-icon", 4, "ngIf"], [1, "invalid-icon"], ["width", "17", "height", "16", "viewBox", "0 0 17 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M8.5 1.45455C4.88505 1.45455 1.95455 4.38505 1.95455 8C1.95455 11.615 4.88505 14.5455 8.5 14.5455C12.115 14.5455 15.0455 11.615 15.0455 8C15.0455 4.38505 12.115 1.45455 8.5 1.45455ZM0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8ZM8.5 4.36364C8.90166 4.36364 9.22727 4.68925 9.22727 5.09091V8C9.22727 8.40166 8.90166 8.72727 8.5 8.72727C8.09834 8.72727 7.77273 8.40166 7.77273 8V5.09091C7.77273 4.68925 8.09834 4.36364 8.5 4.36364ZM7.77273 10.9091C7.77273 10.5074 8.09834 10.1818 8.5 10.1818H8.50727C8.90894 10.1818 9.23455 10.5074 9.23455 10.9091C9.23455 11.3108 8.90894 11.6364 8.50727 11.6364H8.5C8.09834 11.6364 7.77273 11.3108 7.77273 10.9091Z", "fill", "#C2041A"], ["width", "16", "height", "16", "fill", "white", "transform", "translate(0.5)"], [1, "chip-operator-btn"], ["overlayOperatorTrigger", ""], ["solTooltip", "", 3, "trigger", "overflowTooltip", "position", "darkMode", "interactive", "content", "arrow"], ["xmlns", "http://www.w3.org/2000/svg", "width", "6", "height", "4", "viewBox", "0 0 6 4"], ["d", "M4.95918 0.383246L3 2.33579L1.04082 0.383246C0.795918 0.139178 0.428571 0.139178 0.183673 0.383246C-0.0612245 0.627314 -0.0612245 0.993416 0.183673 1.23748L2.57143 3.61715C2.63265 3.67816 2.69388 3.73918 2.7551 3.73918C2.81633 3.8002 2.93878 3.8002 3 3.8002C3.06122 3.8002 3.18367 3.8002 3.2449 3.73918C3.30612 3.67816 3.36735 3.67816 3.42857 3.61715L5.81633 1.23748C6.06122 0.993416 6.06122 0.627314 5.81633 0.383246C5.57143 0.139178 5.20408 0.139178 4.95918 0.383246Z", "fill", "#3F5C69"], [1, "close-icon"], ["type", "button", "tabIndex", "-1", 1, "close-icon-btn", "focusable-item", 3, "click", "keypress"], ["width", "14", "height", "14", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.41058 4.41107C4.73602 4.08563 5.26366 4.08563 5.58909 4.41107L9.99984 8.82181L14.4106 4.41107C14.736 4.08563 15.2637 4.08563 15.5891 4.41107C15.9145 4.73651 15.9145 5.26414 15.5891 5.58958L11.1783 10.0003L15.5891 14.4111C15.9145 14.7365 15.9145 15.2641 15.5891 15.5896C15.2637 15.915 14.736 15.915 14.4106 15.5896L9.99984 11.1788L5.58909 15.5896C5.26366 15.915 4.73602 15.915 4.41058 15.5896C4.08514 15.2641 4.08514 14.7365 4.41058 14.4111L8.82133 10.0003L4.41058 5.58958C4.08514 5.26414 4.08514 4.73651 4.41058 4.41107Z"]],
      template: function QueryChipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("keypress", function QueryChipComponent_Template_div_keypress_0_listener($event) {
            return ctx.enterChipOnEnterOrSpace($event);
          })("keydown.escape", function QueryChipComponent_Template_div_keydown_escape_0_listener($event) {
            return ctx.exitChip($event);
          })("keydown.arrowRight", function QueryChipComponent_Template_div_keydown_arrowRight_0_listener($event) {
            return ctx.moveFocusWithinChip($event);
          })("keydown.arrowLeft", function QueryChipComponent_Template_div_keydown_arrowLeft_0_listener($event) {
            return ctx.moveFocusWithinChip($event);
          })("keydown.arrowDown", function QueryChipComponent_Template_div_keydown_arrowDown_0_listener($event) {
            return $event.preventDefault();
          })("keydown.arrowUp", function QueryChipComponent_Template_div_keydown_arrowUp_0_listener($event) {
            return $event.preventDefault();
          })("keydown.tab", function QueryChipComponent_Template_div_keydown_tab_0_listener() {
            return ctx.moveFocusOutsideChip();
          })("keydown.shift.tab", function QueryChipComponent_Template_div_keydown_shift_tab_0_listener() {
            return ctx.moveFocusOutsideChip();
          });
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵtemplate(2, QueryChipComponent_div_2_Template, 5, 0, "div", 2);
          i0.ɵɵelementStart(3, "span", 3);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(5, QueryChipComponent_div_5_Template, 6, 6, "div", 4);
          i0.ɵɵelementStart(6, "div", 5);
          i0.ɵɵlistener("click", function QueryChipComponent_Template_div_click_6_listener() {
            return ctx.showOverlayOnClick();
          })("keypress", function QueryChipComponent_Template_div_keypress_6_listener($event) {
            return ctx.showOverlayOnEnterOrSpace($event);
          });
          i0.ɵɵelementStart(7, "div", 6, 7);
          i0.ɵɵtemplate(9, QueryChipComponent_span_9_Template, 2, 8, "span", 8)(10, QueryChipComponent_span_10_Template, 3, 3, "span", 9)(11, QueryChipComponent_ng_container_11_Template, 3, 0, "ng-container", 9);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(12, QueryChipComponent_div_12_Template, 5, 3, "div", 10);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("invalid", !ctx.isValid())("empty", ctx.isEmpty())("read-only", ctx.definition.readOnly)("not-clickable", !ctx.canOverlayOpen);
          i0.ɵɵattribute("data-filter-id", ctx.definition.filterId);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c4, ctx.focusWithinChip));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isEmpty() || !ctx.isValid());
          i0.ɵɵadvance();
          i0.ɵɵproperty("trigger", "mouseenter focus")("overflowTooltip", true)("position", "top-start")("darkMode", false)("interactive", false)("content", ctx.definition.filterName)("arrow", true);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1("", ctx.definition.filterName, ":");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.definition.operatorConfig);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c3, ctx.overlayOpen));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.currentSelectionDisplay);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.currentSelectionDisplay);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.canOverlayOpen);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.definition.mandatory);
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgIf, i5.TooltipDirective, i1$2.TranslationPipe],
      styles: [".sol-query-chip[_ngcontent-%COMP%]{overflow:hidden;height:1.75rem;box-sizing:border-box;border-radius:var(--radii-small-allcorners);border:1px solid rgba(61,129,231,.3);display:flex;flex-flow:row;flex-wrap:nowrap;font-family:var(--typography-opensans-body-body1-font-family);background:#3d81e71a;color:#333333e6}.sol-query-chip[_ngcontent-%COMP%]:focus-visible, .sol-query-chip[_ngcontent-%COMP%]:focus-within{outline:var(--color-globalstate-focus) solid 1px}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-name[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none;background:#3d81e726;padding:0 6px;font-family:var(--typography-opensans-body-body1-font-family);font-size:13px;font-weight:600;line-height:1.625rem;height:1.625rem;letter-spacing:0;text-align:left;text-transform:uppercase;max-width:12.5rem;min-width:0;display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:center;gap:.3rem}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-name[_ngcontent-%COMP%]   .truncate[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-name.focus-within-chip[_ngcontent-%COMP%]{background-color:transparent}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-name[_ngcontent-%COMP%]   .invalid-icon[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;height:1rem;width:1.062rem}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]{line-height:1.625rem;height:1.625rem;letter-spacing:0;text-align:left;padding:0 0 0 .5rem;max-width:9.375rem;cursor:pointer}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:hover{background:#3d81e766}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;padding:0 .5rem 0 0;height:1.625rem;border:none;background:transparent;font-family:var(--typography-opensans-body-body1-font-family);color:var(--color-interface-text700);font-size:.813rem;font-weight:400;-webkit-user-select:none;user-select:none}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{min-width:.75rem;pointer-events:none;margin-top:.25rem;margin-bottom:.188rem;margin-left:4px;position:sticky;right:0;top:.75rem}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]{fill:#333333e6}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible, .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active, .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus, .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]{outline:0;background:#3d81e780}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]{color:#000000d9}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-operator-btn[_ngcontent-%COMP%]{color:#333333e6}.sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-value-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-value-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-operator-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-operator-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]{fill:#333333e6}.sol-query-chip.not-clickable[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%], .sol-query-chip.not-clickable[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.not-clickable[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]{cursor:default}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]{min-width:1.5rem}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]{padding:0;min-width:0;height:1.625rem;border:none;background:transparent;cursor:pointer}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:hover{background:#3d81e766}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:focus-visible{outline:0;background:#3d81e780}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{padding:0 .3125rem;height:1.625rem;fill:#333333e6;width:1.5rem;box-sizing:border-box}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:focus-visible   svg[_ngcontent-%COMP%]{fill:#000000d9}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:active{background:transparent}.sol-query-chip[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]{background:#3d81e7cc;fill:#000000d9}.sol-query-chip.invalid[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]{border:1px solid rgba(255,148,0,.5);background:#ff94001f}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-name[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-name[_ngcontent-%COMP%]{color:#333333e6;background:#ff94002e}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-name.focus-within-chip[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-name.focus-within-chip[_ngcontent-%COMP%]{background:transparent;color:#333333e6}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:hover, .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:hover{background:#ff940061}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]{color:#333333e6}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]{fill:var(--color-globalstate-inactive-text)}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible, .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active, .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus, .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible, .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active, .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus, .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]{background:#ff94007a}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus   .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]   .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content.overlay-open[_ngcontent-%COMP%]   .chip-operator-btn[_ngcontent-%COMP%]{color:#000000d9}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-value-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-operator-btn[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-operator-btn[_ngcontent-%COMP%]{color:#333333e6}.sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-value-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-value-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-operator-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-operator-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-value-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-value-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:focus-visible > .chip-operator-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:active > .chip-operator-btn[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]{fill:var(--color-globalstate-inactive-text)}.sol-query-chip.invalid[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:hover, .sol-query-chip.empty[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:hover{background:#ff940061}.sol-query-chip.invalid[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:focus-visible, .sol-query-chip.empty[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:focus-visible{background:#ff94007a}.sol-query-chip.invalid[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:active, .sol-query-chip.empty[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:active{background:transparent}.sol-query-chip.invalid[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%], .sol-query-chip.empty[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   .close-icon-btn[_ngcontent-%COMP%]:active   svg[_ngcontent-%COMP%]{background:#ff9400c7}.sol-query-chip.read-only[_ngcontent-%COMP%]:not(.invalid), .sol-query-chip.read-only[_ngcontent-%COMP%]:not(.empty), .sol-query-chip.read-only.invalid[_ngcontent-%COMP%], .sol-query-chip.read-only.empty[_ngcontent-%COMP%]{background-color:#fff;border-color:var(--color-globalstate-disabled-border)}.sol-query-chip.read-only[_ngcontent-%COMP%]:not(.invalid)   .chip-filter-name[_ngcontent-%COMP%], .sol-query-chip.read-only[_ngcontent-%COMP%]:not(.empty)   .chip-filter-name[_ngcontent-%COMP%], .sol-query-chip.read-only.invalid[_ngcontent-%COMP%]   .chip-filter-name[_ngcontent-%COMP%], .sol-query-chip.read-only.empty[_ngcontent-%COMP%]   .chip-filter-name[_ngcontent-%COMP%]{background-color:var(--color-globalstate-disabled-background)}.sol-query-chip.read-only[_ngcontent-%COMP%]:not(.invalid)   .chip-filter-content[_ngcontent-%COMP%], .sol-query-chip.read-only[_ngcontent-%COMP%]:not(.empty)   .chip-filter-content[_ngcontent-%COMP%], .sol-query-chip.read-only.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%], .sol-query-chip.read-only.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]{background-color:#fff}.sol-query-chip.read-only[_ngcontent-%COMP%]:not(.invalid)   .chip-filter-content[_ngcontent-%COMP%]:hover, .sol-query-chip.read-only[_ngcontent-%COMP%]:not(.empty)   .chip-filter-content[_ngcontent-%COMP%]:hover, .sol-query-chip.read-only.invalid[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:hover, .sol-query-chip.read-only.empty[_ngcontent-%COMP%]   .chip-filter-content[_ngcontent-%COMP%]:hover{background-color:#fff}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QueryChipComponent, [{
    type: Component,
    args: [{
      selector: 'sol-query-chip',
      providers: [QueryChipOverlayService, QueryChipOverlayRefService] // Provide the service at the component level
      ,
      template: "<div\n  class=\"sol-query-chip\"\n  tabindex=\"0\"\n  [class.invalid]=\"!isValid()\"\n  [class.empty]=\"isEmpty()\"\n  [class.read-only]=\"definition.readOnly\"\n  [class.not-clickable]=\"!canOverlayOpen\"\n  (keypress)=\"enterChipOnEnterOrSpace($event)\"\n  (keydown.escape)=\"exitChip($event)\"\n  (keydown.arrowRight)=\"moveFocusWithinChip($event)\"\n  (keydown.arrowLeft)=\"moveFocusWithinChip($event)\"\n  (keydown.arrowDown)=\"$event.preventDefault()\"\n  (keydown.arrowUp)=\"$event.preventDefault()\"\n  (keydown.tab)=\"moveFocusOutsideChip()\"\n  (keydown.shift.tab)=\"moveFocusOutsideChip()\"\n  [attr.data-filter-id]=\"definition.filterId\"\n>\n  <div class=\"chip-filter-name\" [ngClass]=\"{ 'focus-within-chip': focusWithinChip }\">\n    <div *ngIf=\"isEmpty() || !isValid()\" class=\"invalid-icon\">\n      <svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path\n          fill-rule=\"evenodd\"\n          clip-rule=\"evenodd\"\n          d=\"M8.5 1.45455C4.88505 1.45455 1.95455 4.38505 1.95455 8C1.95455 11.615 4.88505 14.5455 8.5 14.5455C12.115 14.5455 15.0455 11.615 15.0455 8C15.0455 4.38505 12.115 1.45455 8.5 1.45455ZM0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8ZM8.5 4.36364C8.90166 4.36364 9.22727 4.68925 9.22727 5.09091V8C9.22727 8.40166 8.90166 8.72727 8.5 8.72727C8.09834 8.72727 7.77273 8.40166 7.77273 8V5.09091C7.77273 4.68925 8.09834 4.36364 8.5 4.36364ZM7.77273 10.9091C7.77273 10.5074 8.09834 10.1818 8.5 10.1818H8.50727C8.90894 10.1818 9.23455 10.5074 9.23455 10.9091C9.23455 11.3108 8.90894 11.6364 8.50727 11.6364H8.5C8.09834 11.6364 7.77273 11.3108 7.77273 10.9091Z\"\n          fill=\"#C2041A\"\n        />\n        <defs>\n          <rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(0.5)\" />\n        </defs>\n      </svg>\n    </div>\n    <span\n      class=\"truncate\"\n      solTooltip\n      [trigger]=\"'mouseenter focus'\"\n      [overflowTooltip]=\"true\"\n      [position]=\"'top-start'\"\n      [darkMode]=\"false\"\n      [interactive]=\"false\"\n      [content]=\"definition.filterName\"\n      [arrow]=\"true\"\n      >{{ definition.filterName }}:</span\n    >\n  </div>\n  <div\n    tabIndex=\"-1\"\n    *ngIf=\"definition.operatorConfig\"\n    class=\"chip-filter-content focusable-item\"\n    (click)=\"showOperatorOverlayOnClick()\"\n    (keypress)=\"showOperatorOverlayOnEnterOrSpace($event)\"\n    [ngClass]=\"{ 'overlay-open': operatorOverlayOpen }\"\n  >\n    <div #overlayOperatorTrigger class=\"chip-operator-btn\">\n      <span\n        *ngIf=\"currentOperatorSelectionDisplay\"\n        solTooltip\n        [trigger]=\"'mouseenter focus'\"\n        [overflowTooltip]=\"true\"\n        [position]=\"'top-start'\"\n        [darkMode]=\"false\"\n        [interactive]=\"false\"\n        [content]=\"currentOperatorSelectionDisplay\"\n        [arrow]=\"true\"\n        >{{ currentOperatorSelectionDisplay }}</span\n      >\n      <span *ngIf=\"!currentOperatorSelectionDisplay\">{{ 'queryChipOperatorText' | translate }}</span>\n      <ng-container *ngIf=\"canOverlayOpen\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"6\" height=\"4\" viewBox=\"0 0 6 4\">\n          <path\n            d=\"M4.95918 0.383246L3 2.33579L1.04082 0.383246C0.795918 0.139178 0.428571 0.139178 0.183673 0.383246C-0.0612245 0.627314 -0.0612245 0.993416 0.183673 1.23748L2.57143 3.61715C2.63265 3.67816 2.69388 3.73918 2.7551 3.73918C2.81633 3.8002 2.93878 3.8002 3 3.8002C3.06122 3.8002 3.18367 3.8002 3.2449 3.73918C3.30612 3.67816 3.36735 3.67816 3.42857 3.61715L5.81633 1.23748C6.06122 0.993416 6.06122 0.627314 5.81633 0.383246C5.57143 0.139178 5.20408 0.139178 4.95918 0.383246Z\"\n            fill=\"#3F5C69\"\n          />\n        </svg>\n      </ng-container>\n    </div>\n  </div>\n  <div\n    tabIndex=\"-1\"\n    class=\"chip-filter-content focusable-item\"\n    (click)=\"showOverlayOnClick()\"\n    (keypress)=\"showOverlayOnEnterOrSpace($event)\"\n    [ngClass]=\"{ 'overlay-open': overlayOpen }\"\n  >\n    <div #overlayTrigger class=\"chip-value-btn\">\n      <span\n        *ngIf=\"currentSelectionDisplay\"\n        solTooltip\n        [trigger]=\"'mouseenter focus'\"\n        [overflowTooltip]=\"true\"\n        [position]=\"'top-start'\"\n        [darkMode]=\"false\"\n        [interactive]=\"false\"\n        [content]=\"currentSelectionDisplay\"\n        [arrow]=\"true\"\n        >{{ currentSelectionDisplay }}</span\n      >\n      <span *ngIf=\"!currentSelectionDisplay\">{{ 'queryChipSelectText' | translate }}</span>\n      <ng-container *ngIf=\"canOverlayOpen\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"6\" height=\"4\" viewBox=\"0 0 6 4\">\n          <path\n            d=\"M4.95918 0.383246L3 2.33579L1.04082 0.383246C0.795918 0.139178 0.428571 0.139178 0.183673 0.383246C-0.0612245 0.627314 -0.0612245 0.993416 0.183673 1.23748L2.57143 3.61715C2.63265 3.67816 2.69388 3.73918 2.7551 3.73918C2.81633 3.8002 2.93878 3.8002 3 3.8002C3.06122 3.8002 3.18367 3.8002 3.2449 3.73918C3.30612 3.67816 3.36735 3.67816 3.42857 3.61715L5.81633 1.23748C6.06122 0.993416 6.06122 0.627314 5.81633 0.383246C5.57143 0.139178 5.20408 0.139178 4.95918 0.383246Z\"\n            fill=\"#3F5C69\"\n          />\n        </svg>\n      </ng-container>\n    </div>\n  </div>\n  <div *ngIf=\"!definition.mandatory\" class=\"close-icon\">\n    <button\n      type=\"button\"\n      tabIndex=\"-1\"\n      class=\"close-icon-btn focusable-item\"\n      (click)=\"removeChip()\"\n      (keypress)=\"removeChipOnEnterOrSpace($event)\"\n      [attr.aria-label]=\"('remove' | translate) + ': ' + definition.filterName\"\n    >\n      <svg width=\"14\" height=\"14\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path\n          fill-rule=\"evenodd\"\n          clip-rule=\"evenodd\"\n          d=\"M4.41058 4.41107C4.73602 4.08563 5.26366 4.08563 5.58909 4.41107L9.99984 8.82181L14.4106 4.41107C14.736 4.08563 15.2637 4.08563 15.5891 4.41107C15.9145 4.73651 15.9145 5.26414 15.5891 5.58958L11.1783 10.0003L15.5891 14.4111C15.9145 14.7365 15.9145 15.2641 15.5891 15.5896C15.2637 15.915 14.736 15.915 14.4106 15.5896L9.99984 11.1788L5.58909 15.5896C5.26366 15.915 4.73602 15.915 4.41058 15.5896C4.08514 15.2641 4.08514 14.7365 4.41058 14.4111L8.82133 10.0003L4.41058 5.58958C4.08514 5.26414 4.08514 4.73651 4.41058 4.41107Z\"\n        />\n      </svg>\n    </button>\n  </div>\n</div>\n",
      styles: [".sol-query-chip{overflow:hidden;height:1.75rem;box-sizing:border-box;border-radius:var(--radii-small-allcorners);border:1px solid rgba(61,129,231,.3);display:flex;flex-flow:row;flex-wrap:nowrap;font-family:var(--typography-opensans-body-body1-font-family);background:#3d81e71a;color:#333333e6}.sol-query-chip:focus-visible,.sol-query-chip:focus-within{outline:var(--color-globalstate-focus) solid 1px}.sol-query-chip .chip-filter-name{-webkit-user-select:none;user-select:none;background:#3d81e726;padding:0 6px;font-family:var(--typography-opensans-body-body1-font-family);font-size:13px;font-weight:600;line-height:1.625rem;height:1.625rem;letter-spacing:0;text-align:left;text-transform:uppercase;max-width:12.5rem;min-width:0;display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:center;gap:.3rem}.sol-query-chip .chip-filter-name .truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block}.sol-query-chip .chip-filter-name.focus-within-chip{background-color:transparent}.sol-query-chip .chip-filter-name .invalid-icon{display:flex;flex-direction:column;justify-content:center;height:1rem;width:1.062rem}.sol-query-chip .chip-filter-content{line-height:1.625rem;height:1.625rem;letter-spacing:0;text-align:left;padding:0 0 0 .5rem;max-width:9.375rem;cursor:pointer}.sol-query-chip .chip-filter-content:hover{background:#3d81e766}.sol-query-chip .chip-filter-content .chip-value-btn,.sol-query-chip .chip-filter-content .chip-operator-btn{display:flex;flex-wrap:nowrap;padding:0 .5rem 0 0;height:1.625rem;border:none;background:transparent;font-family:var(--typography-opensans-body-body1-font-family);color:var(--color-interface-text700);font-size:.813rem;font-weight:400;-webkit-user-select:none;user-select:none}.sol-query-chip .chip-filter-content .chip-value-btn span,.sol-query-chip .chip-filter-content .chip-operator-btn span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block}.sol-query-chip .chip-filter-content .chip-value-btn svg,.sol-query-chip .chip-filter-content .chip-operator-btn svg{min-width:.75rem;pointer-events:none;margin-top:.25rem;margin-bottom:.188rem;margin-left:4px;position:sticky;right:0;top:.75rem}.sol-query-chip .chip-filter-content .chip-value-btn svg>path,.sol-query-chip .chip-filter-content .chip-operator-btn svg>path{fill:#333333e6}.sol-query-chip .chip-filter-content:focus-visible,.sol-query-chip .chip-filter-content:active,.sol-query-chip .chip-filter-content:focus,.sol-query-chip .chip-filter-content.overlay-open{outline:0;background:#3d81e780}.sol-query-chip .chip-filter-content:focus-visible .chip-value-btn,.sol-query-chip .chip-filter-content:focus-visible .chip-operator-btn,.sol-query-chip .chip-filter-content:active .chip-value-btn,.sol-query-chip .chip-filter-content:active .chip-operator-btn,.sol-query-chip .chip-filter-content:focus .chip-value-btn,.sol-query-chip .chip-filter-content:focus .chip-operator-btn,.sol-query-chip .chip-filter-content.overlay-open .chip-value-btn,.sol-query-chip .chip-filter-content.overlay-open .chip-operator-btn{color:#000000d9}.sol-query-chip .chip-filter-content:focus-visible>.chip-value-btn,.sol-query-chip .chip-filter-content:active>.chip-value-btn,.sol-query-chip .chip-filter-content:focus-visible>.chip-operator-btn,.sol-query-chip .chip-filter-content:active>.chip-operator-btn{color:#333333e6}.sol-query-chip .chip-filter-content:focus-visible>.chip-value-btn>svg>path,.sol-query-chip .chip-filter-content:active>.chip-value-btn>svg>path,.sol-query-chip .chip-filter-content:focus-visible>.chip-operator-btn>svg>path,.sol-query-chip .chip-filter-content:active>.chip-operator-btn>svg>path{fill:#333333e6}.sol-query-chip.not-clickable .chip-filter-content,.sol-query-chip.not-clickable .chip-filter-content .chip-value-btn,.sol-query-chip.not-clickable .chip-filter-content .chip-operator-btn{cursor:default}.sol-query-chip .close-icon{min-width:1.5rem}.sol-query-chip .close-icon .close-icon-btn{padding:0;min-width:0;height:1.625rem;border:none;background:transparent;cursor:pointer}.sol-query-chip .close-icon .close-icon-btn:hover{background:#3d81e766}.sol-query-chip .close-icon .close-icon-btn:focus-visible{outline:0;background:#3d81e780}.sol-query-chip .close-icon .close-icon-btn svg{padding:0 .3125rem;height:1.625rem;fill:#333333e6;width:1.5rem;box-sizing:border-box}.sol-query-chip .close-icon .close-icon-btn:focus-visible svg{fill:#000000d9}.sol-query-chip .close-icon .close-icon-btn:active{background:transparent}.sol-query-chip .close-icon .close-icon-btn:active svg{background:#3d81e7cc;fill:#000000d9}.sol-query-chip.invalid,.sol-query-chip.empty{border:1px solid rgba(255,148,0,.5);background:#ff94001f}.sol-query-chip.invalid .chip-filter-name,.sol-query-chip.empty .chip-filter-name{color:#333333e6;background:#ff94002e}.sol-query-chip.invalid .chip-filter-name.focus-within-chip,.sol-query-chip.empty .chip-filter-name.focus-within-chip{background:transparent;color:#333333e6}.sol-query-chip.invalid .chip-filter-content:hover,.sol-query-chip.empty .chip-filter-content:hover{background:#ff940061}.sol-query-chip.invalid .chip-filter-content .chip-value-btn,.sol-query-chip.invalid .chip-filter-content .chip-operator-btn,.sol-query-chip.empty .chip-filter-content .chip-value-btn,.sol-query-chip.empty .chip-filter-content .chip-operator-btn{color:#333333e6}.sol-query-chip.invalid .chip-filter-content .chip-value-btn svg>path,.sol-query-chip.invalid .chip-filter-content .chip-operator-btn svg>path,.sol-query-chip.empty .chip-filter-content .chip-value-btn svg>path,.sol-query-chip.empty .chip-filter-content .chip-operator-btn svg>path{fill:var(--color-globalstate-inactive-text)}.sol-query-chip.invalid .chip-filter-content:focus-visible,.sol-query-chip.invalid .chip-filter-content:active,.sol-query-chip.invalid .chip-filter-content:focus,.sol-query-chip.invalid .chip-filter-content.overlay-open,.sol-query-chip.empty .chip-filter-content:focus-visible,.sol-query-chip.empty .chip-filter-content:active,.sol-query-chip.empty .chip-filter-content:focus,.sol-query-chip.empty .chip-filter-content.overlay-open{background:#ff94007a}.sol-query-chip.invalid .chip-filter-content:focus-visible .chip-value-btn,.sol-query-chip.invalid .chip-filter-content:focus-visible .chip-operator-btn,.sol-query-chip.invalid .chip-filter-content:active .chip-value-btn,.sol-query-chip.invalid .chip-filter-content:active .chip-operator-btn,.sol-query-chip.invalid .chip-filter-content:focus .chip-value-btn,.sol-query-chip.invalid .chip-filter-content:focus .chip-operator-btn,.sol-query-chip.invalid .chip-filter-content.overlay-open .chip-value-btn,.sol-query-chip.invalid .chip-filter-content.overlay-open .chip-operator-btn,.sol-query-chip.empty .chip-filter-content:focus-visible .chip-value-btn,.sol-query-chip.empty .chip-filter-content:focus-visible .chip-operator-btn,.sol-query-chip.empty .chip-filter-content:active .chip-value-btn,.sol-query-chip.empty .chip-filter-content:active .chip-operator-btn,.sol-query-chip.empty .chip-filter-content:focus .chip-value-btn,.sol-query-chip.empty .chip-filter-content:focus .chip-operator-btn,.sol-query-chip.empty .chip-filter-content.overlay-open .chip-value-btn,.sol-query-chip.empty .chip-filter-content.overlay-open .chip-operator-btn{color:#000000d9}.sol-query-chip.invalid .chip-filter-content:focus-visible>.chip-value-btn,.sol-query-chip.invalid .chip-filter-content:active>.chip-value-btn,.sol-query-chip.invalid .chip-filter-content:focus-visible>.chip-operator-btn,.sol-query-chip.invalid .chip-filter-content:active>.chip-operator-btn,.sol-query-chip.empty .chip-filter-content:focus-visible>.chip-value-btn,.sol-query-chip.empty .chip-filter-content:active>.chip-value-btn,.sol-query-chip.empty .chip-filter-content:focus-visible>.chip-operator-btn,.sol-query-chip.empty .chip-filter-content:active>.chip-operator-btn{color:#333333e6}.sol-query-chip.invalid .chip-filter-content:focus-visible>.chip-value-btn>svg>path,.sol-query-chip.invalid .chip-filter-content:active>.chip-value-btn>svg>path,.sol-query-chip.invalid .chip-filter-content:focus-visible>.chip-operator-btn>svg>path,.sol-query-chip.invalid .chip-filter-content:active>.chip-operator-btn>svg>path,.sol-query-chip.empty .chip-filter-content:focus-visible>.chip-value-btn>svg>path,.sol-query-chip.empty .chip-filter-content:active>.chip-value-btn>svg>path,.sol-query-chip.empty .chip-filter-content:focus-visible>.chip-operator-btn>svg>path,.sol-query-chip.empty .chip-filter-content:active>.chip-operator-btn>svg>path{fill:var(--color-globalstate-inactive-text)}.sol-query-chip.invalid .close-icon .close-icon-btn:hover,.sol-query-chip.empty .close-icon .close-icon-btn:hover{background:#ff940061}.sol-query-chip.invalid .close-icon .close-icon-btn:focus-visible,.sol-query-chip.empty .close-icon .close-icon-btn:focus-visible{background:#ff94007a}.sol-query-chip.invalid .close-icon .close-icon-btn:active,.sol-query-chip.empty .close-icon .close-icon-btn:active{background:transparent}.sol-query-chip.invalid .close-icon .close-icon-btn:active svg,.sol-query-chip.empty .close-icon .close-icon-btn:active svg{background:#ff9400c7}.sol-query-chip.read-only:not(.invalid),.sol-query-chip.read-only:not(.empty),.sol-query-chip.read-only.invalid,.sol-query-chip.read-only.empty{background-color:#fff;border-color:var(--color-globalstate-disabled-border)}.sol-query-chip.read-only:not(.invalid) .chip-filter-name,.sol-query-chip.read-only:not(.empty) .chip-filter-name,.sol-query-chip.read-only.invalid .chip-filter-name,.sol-query-chip.read-only.empty .chip-filter-name{background-color:var(--color-globalstate-disabled-background)}.sol-query-chip.read-only:not(.invalid) .chip-filter-content,.sol-query-chip.read-only:not(.empty) .chip-filter-content,.sol-query-chip.read-only.invalid .chip-filter-content,.sol-query-chip.read-only.empty .chip-filter-content{background-color:#fff}.sol-query-chip.read-only:not(.invalid) .chip-filter-content:hover,.sol-query-chip.read-only:not(.empty) .chip-filter-content:hover,.sol-query-chip.read-only.invalid .chip-filter-content:hover,.sol-query-chip.read-only.empty .chip-filter-content:hover{background-color:#fff}\n"]
    }]
  }], () => [{
    type: i0.NgZone
  }, {
    type: i0.ElementRef
  }, {
    type: i1$2.TranslationService
  }, {
    type: FilterTypeRegistryService
  }, {
    type: QueryChipOverlayService
  }], {
    overlayTrigger: [{
      type: ViewChild,
      args: ['overlayTrigger']
    }],
    overlayOperatorTrigger: [{
      type: ViewChild,
      args: ['overlayOperatorTrigger']
    }],
    definition: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    operator: [{
      type: Input
    }],
    chipRemoved: [{
      type: Output
    }],
    chipValueChanged: [{
      type: Output
    }],
    onTouch: [{
      type: Output
    }]
  });
})();
class QueryBuilderUtils {
  static getDelimitedArray(input, customSeparators) {
    if (customSeparators && customSeparators.length > 0) {
      const regex = /[-\/\\^$*+?.()|[\]{}]/g; //  pattern for special character eg: -,\,//,^,$,*,+,?,.,{,},|,(,),[,]
      const escapedSeparators = customSeparators.map(separator => {
        return separator.replace(regex, '\\$&'); // Escape special characters
      });
      const separatorsPattern = escapedSeparators.join('|'); // Combine escaped separators
      const separators = new RegExp(separatorsPattern); // Create regex from custom separators
      const processedArray = input.split(separators) // Split input using custom separators
      .map(item => item.trim()) // Trim leading and trailing whitespaces
      .filter(item => item !== ''); // Remove empty items after trimming
      return processedArray;
    }
    return [input];
  }
}
class QueryFilterType {
  static {
    this.supportsReadOnly = false;
  }
  constructor(injector) {
    this.overlayConfigData = inject(FILTER_COMPONENT_INJECTED_DATA);
    this.readOnly = false;
    // load values from overlayRef
    this.overlayRef = injector.get(QueryChipOverlayRefService);
    this.updateValue(this.overlayConfigData.selection);
    this.updateMetadata(this.overlayConfigData.metadata);
    this.filterConfig = this.overlayConfigData.filterConfig;
    this.readOnly = !!this.overlayConfigData.readOnly;
    // call child class's saveMetadataFn() (if defined) when the overlay is closed
    this.overlayRef.onOverlayClose = () => {
      if (this.saveMetadataFn && typeof this.saveMetadataFn === 'function') {
        this.overlayRef.updateMetadata(this.saveMetadataFn());
      }
    };
    // call child class's loadMetadataFn() (if defined) when the overlay is opened
    setTimeout(() => {
      if (this.metadata && this.loadMetadataFn && typeof this.loadMetadataFn == 'function') {
        this.loadMetadataFn(this.metadata);
      }
    });
  }
  closeOverlay() {
    this.overlayRef.close(CloseOverlayEventType.FILTER_CLICK);
  }
  updateValue(value) {
    this.selection = value;
    this.overlayRef.updateValue(value);
  }
  updateMetadata(value) {
    this.metadata = value;
    this.overlayRef.updateMetadata(value);
  }
  static {
    this.ɵfac = function QueryFilterType_Factory(t) {
      return new (t || QueryFilterType)(i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: QueryFilterType,
      factory: QueryFilterType.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QueryFilterType, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();
class TagFilterTypeComponent extends QueryFilterType {
  constructor(injector, translationService) {
    super(injector);
    this.translationService = translationService;
    this.tags = [];
    this.textInputValue = '';
    this.isInputDisabled = false;
    this.unformattedTags = [];
    this.inputMode = 'text';
    this.setContainerSize = 'medium';
    this.isInputError = false;
    this.maxTags = 100;
    this.textInputMaxCharacters = 5000;
    this.maxTagsUpperLimit = 2000; // maxTags cannot be configured higher than this limit
    this.textInputMaxCharactersUpperLimit = 20000; // textInputMaxCharacters cannot be configured higher than this limit
    this.queryTagLimitWarning = '';
    this.queryTagInputTextLimitWarning = '';
    this.queryTagDuplicateTextNotice = this.translationService.getTranslation('queryTagDuplicateTextNotice');
    this.queryTagUnsupportedTextNotice = this.translationService.getTranslation('queryTagUnsupportedTextNotice');
    this.tagTypePlural = this.translationService.getTranslation('queryTagPlural');
    this.queryTagInputPlaceholder = this.translationService.getTranslation('queryTagInputPlaceholder', this.tagTypePlural);
    this.searchTerm = new FormControl();
    this.numOfOptions = 0;
    this.loading = false;
    this.showNotice = {
      duplicateText: false,
      unsupportedText: false,
      tagLimit: false
    };
    this.saveMetadataFn = () => {
      return {
        textInputValue: this.textInputValue,
        autoCompleteValue: this.searchTerm.value
      };
    };
    this.loadMetadataFn = metadata => {
      if (metadata && metadata.textInputValue) {
        this.textInputValue = metadata.textInputValue;
      }
      if (metadata && metadata.autoCompleteValue) {
        this.searchTerm.patchValue(metadata.autoCompleteValue);
      }
    };
    this.checkDuplicate = () => {
      const uniqueChip = {};
      const duplicateChip = [];
      this.tags?.forEach(({
        label
      }, i) => {
        if (uniqueChip[label.toLowerCase()] === undefined) {
          uniqueChip[label.toLowerCase()] = i;
        }
      });
      this.tags?.forEach((chip, index) => {
        if (Object.values(uniqueChip).includes(index)) {
          chip.isValid = true;
        } else {
          chip.isValid = false;
          duplicateChip.push(chip);
        }
      });
    };
  }
  resetNotices() {
    for (const [notice] of Object.entries(this.showNotice)) {
      this.showNotice[notice] = false;
    }
  }
  ngOnInit() {
    this.initializeComponent();
    if (this.isAutocompleteMode()) {
      this.setupFilteredOptions();
    }
  }
  initializeComponent() {
    this.setChipConfig();
    this.setSelectedChipValue();
  }
  isAutocompleteMode() {
    return this.inputMode === 'autocomplete';
  }
  setupFilteredOptions() {
    this.filteredOptions = this.searchTerm.valueChanges.pipe(startWith(''), tap(() => this.startLoading()), switchMap(() => this.getOptionsWrapper()), tap(() => this.stopLoading()), map(options => this.processOptions(options)));
  }
  startLoading() {
    this.loading = true;
  }
  getOptionsWrapper() {
    return this.filterConfig.autocompleteConfig.getOptions(this.searchTerm.value || '', this.tags);
  }
  stopLoading() {
    this.loading = false;
  }
  processOptions(options) {
    this.numOfOptions = 0;
    if (options.length > 0) {
      this.numOfOptions = options.length;
      this.setFilterTypeSize(true);
    } else {
      this.setFilterTypeSize(false);
    }
    return options;
  }
  addChipToContainerFromAutocomplete(value) {
    this.addTagsToContainer([{
      label: value.option.value,
      isValid: true,
      returnValue: value.option.id
    }]);
    this.searchTerm.patchValue('');
    this.setFilterTypeSize(false);
  }
  autocompleteDropdownUpdate(isVisible) {
    this.setFilterTypeSize(isVisible && this.numOfOptions > 0);
  }
  setFilterTypeSize(updateSize) {
    this.setContainerSize = updateSize ? 'large' : 'medium';
  }
  setSelectedChipValue() {
    if (this.selection !== undefined && this.inputMode === 'autocomplete' && this.objectLabel) {
      this.tags = this.selection.map(res => ({
        label: res[this.objectLabel],
        returnValue: res
      }));
    } else if (this.selection !== undefined) {
      this.tags = this.selection.map(res => ({
        label: res,
        returnValue: res
      }));
    }
    this.checkDuplicate();
  }
  setChipConfig() {
    if (this.filterConfig) {
      if (this.filterConfig.textInputMaxCharactersPerTag > 0) {
        this.textInputMaxCharactersPerTag = this.filterConfig.textInputMaxCharactersPerTag;
      }
      if (this.filterConfig.textInputTagRegex) {
        if (this.filterConfig.textInputTagRegex instanceof RegExp) {
          this.textInputTagRegex = this.filterConfig.textInputTagRegex;
        } else {
          console.error('Property textInputTagRegex must be a RegExp object, not a String.');
        }
      }
      this.textInputMaxCharacters = this.filterConfig.textInputMaxCharacters || this.textInputMaxCharacters;
      if (this.textInputMaxCharacters > this.textInputMaxCharactersUpperLimit) {
        this.textInputMaxCharacters = this.textInputMaxCharactersUpperLimit;
      }
      this.maxTags = this.filterConfig.maxTags || this.maxTags;
      if (this.maxTags > this.maxTagsUpperLimit) {
        this.maxTags = this.maxTagsUpperLimit;
      }
      this.inputMode = this.filterConfig.inputMode || this.inputMode;
      this.tagTypePlural = this.filterConfig.tagTypePlural || this.tagTypePlural;
      this.queryTagInputPlaceholder = this.filterConfig.textInputPlaceholder || this.queryTagInputPlaceholder;
      this.objectLabel = this.filterConfig.objectLabel;
    }
    this.queryTagInputTextLimitWarning = this.translationService.getTranslation('queryTagInputTextLimitWarning', this.textInputMaxCharacters);
  }
  onValueChange(value) {
    this.textInputValue = value;
    this.isInputError = this.textInputValue.length > this.textInputMaxCharacters;
  }
  addChipToContainerFromTextInput(event) {
    const inputValue = event?.target?.value;
    if (event && event.code === 'Enter') {
      event.preventDefault();
    }
    if (inputValue?.length <= this.textInputMaxCharacters) {
      let newTagTextArray = QueryBuilderUtils.getDelimitedArray(inputValue, [',', ';', '\n']);
      let aTagWasRemovedAsDuplicate = false;
      let aTagWasRemovedAsInvalid = false;
      let tagCountBeforeOperation = newTagTextArray.length;
      // 1. Check for Duplicates
      tagCountBeforeOperation = newTagTextArray.length;
      //     1a. make the list of new tags unique
      newTagTextArray = newTagTextArray.filter((value, index, array) => array.indexOf(value) === index);
      //     1b. check if a new tag already exists as a chip before adding
      const tagsLabel = this.tags.map(tag => tag.label);
      newTagTextArray = newTagTextArray.filter(value => tagsLabel.indexOf(value) === -1);
      //     check the count to see if any were removed as duplicates
      if (tagCountBeforeOperation > newTagTextArray.length) {
        aTagWasRemovedAsDuplicate = true;
      }
      // 2. Check for invalid values
      tagCountBeforeOperation = newTagTextArray.length;
      //     2a. remove new tags if they are too long
      if (this.textInputMaxCharactersPerTag) {
        newTagTextArray = newTagTextArray.filter(tagText => {
          return tagText.length <= this.textInputMaxCharactersPerTag;
        });
      }
      //     2b. remove new tags if they do not match the regex
      // remove new tags if they do not match the regex
      if (this.textInputTagRegex instanceof RegExp) {
        newTagTextArray = newTagTextArray.filter(newTag => {
          return this.textInputTagRegex.test(newTag);
        });
      }
      //     check the count to see if any were removed as invalid
      if (tagCountBeforeOperation > newTagTextArray.length) {
        aTagWasRemovedAsInvalid = true;
      }
      const newTagObjectArray = newTagTextArray.map(value => ({
        label: value,
        isValid: true,
        returnValue: value
      }));
      tagCountBeforeOperation = this.tags.length + newTagTextArray.length;
      this.addTagsToContainer(newTagObjectArray);
      this.textInputValue = '';
      // check for notices
      if (tagCountBeforeOperation > this.tags.length) {
        const tagsAdded = newTagTextArray.length - (tagCountBeforeOperation - this.tags.length);
        if (tagsAdded === 1) {
          this.queryTagLimitWarning = this.translationService.getTranslation('queryTagMaxExceeded1Notice');
        } else {
          this.queryTagLimitWarning = this.translationService.getTranslation('queryTagMaxExceededNotice', tagsAdded);
        }
        this.showNotice.tagLimit = true;
      }
      if (aTagWasRemovedAsDuplicate) {
        this.showNotice.duplicateText = true;
      }
      if (aTagWasRemovedAsInvalid) {
        this.showNotice.unsupportedText = true;
      }
    } else {
      this.isInputError = true;
    }
  }
  addTagsToContainer(newTags) {
    this.unformattedTags = [...this.tags, ...newTags];
    this.tags = this.unformattedTags.slice(0, this.maxTags);
    this.queryTagLimitWarning = this.translationService.getTranslation('queryTagLimitWarning', this.maxTags, this.tagTypePlural);
    this.checkDuplicate();
    this.updateQueryChipValue(this.tags);
  }
  clearAllTags() {
    this.tags = [];
    this.unformattedTags = [];
    this.updateQueryChipValue(this.tags);
  }
  updateQueryChipValue(tags) {
    const updatedTags = tags.map(items => items.returnValue);
    this.resetNotices();
    this.updateValue(updatedTags);
  }
  removeItem(index) {
    this.tags.splice(index, 1);
    this.unformattedTags = [...this.tags];
    /* To check Deleted tag is valid or not */
    this.checkDuplicate();
    if (this.tags.length) {
      // if closed chip is not the first chip then focus returns to the previous chip
      if (index > 0) {
        this.focusCloseButton(index - 1);
      } else if (index === 0) {
        this.focusNextChip(index);
      }
    }
    this.updateQueryChipValue(this.tags);
  }
  onChipKeydown(event, index) {
    if (event.code === 'ArrowLeft') {
      //if chip focus to previous chip
      if (index > 0) {
        this.focusCloseButton(index - 1);
      }
      // if it is the first chip
      else if (index === 0) {
        this.focusCloseButton(this.tags.length - 1);
      }
    } else if (event.code === 'ArrowRight') {
      // functionality same as close button right keydown
      this.focusCloseButton(index);
    }
  }
  /* for focus and keyboard accessability */
  onCloseButtonKeydown(event, index) {
    if (event.code === 'ArrowRight') {
      if (index < this.tags.length - 1) {
        this.focusNextChip(index);
      } else {
        this.focusFirstChip();
      }
    }
  }
  focusFirstChip() {
    const chips = this.solChipEleRef.nativeElement.querySelectorAll('.chip-container .sol-chip');
    if (chips.length > 0) {
      chips[0].focus();
      return;
    }
  }
  focusNextChip(index) {
    const chips = this.solChipEleRef.nativeElement.querySelectorAll('.chip-container .sol-chip');
    if (chips.length > 0) {
      chips[index + 1].focus();
      return;
    }
  }
  focusCloseButton(index) {
    const closeButtons = this.solChipEleRef.nativeElement.querySelectorAll('.chip-container .sol-chip .close-icon');
    if (closeButtons.length > 0) {
      setTimeout(() => closeButtons[index].focus(), 0);
      return;
    }
  }
  static {
    this.ɵfac = function TagFilterTypeComponent_Factory(t) {
      return new (t || TagFilterTypeComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$2.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TagFilterTypeComponent,
      selectors: [["tag-filter-type"]],
      viewQuery: function TagFilterTypeComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.solChipEleRef = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 30,
      vars: 28,
      consts: [[1, "tag-filter-type", 3, "ngClass"], [1, "input-container"], [3, "ngTemplateOutlet"], ["text", ""], ["autocomplete", ""], ["class", "chip-container", 4, "ngIf"], [1, "footer-container"], [1, "notice-container"], ["class", "notice visible", "data-notice", "textInputMaxCharacters", 4, "ngIf"], ["data-notice", "tagLimit", 1, "notice", 3, "ngClass"], [4, "ngTemplateOutlet"], ["data-notice", "duplicateText", 1, "notice", 3, "ngClass"], ["data-notice", "unsupportedText", 1, "notice", 3, "ngClass"], [1, "info-cls"], [1, "clear-btn"], [3, "variant", "size", "disabled", "disabledAltState", "click"], ["noticeIcon", ""], ["errorIcon", ""], [3, "labelText", "placeholder", "value", "disabled", "minRows", "maxRows", "cols", "wrap", "errorState", "errorMessageText", "resizeTextarea", "keydown.enter", "keydown.tab", "valueChange"], [2, "margin-bottom", "7px"], ["placeholder", "item", "ariaLabel", "item", 3, "formControl", "minimumSearchTextLength", "optionSelected", "dropdownVisible"], ["id", "loading", "name", "loading", 3, "disabled", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["id", "loading", "name", "loading", 3, "disabled"], [2, "height", "40px"], [3, "isSpinner", "id"], [3, "id", "name", 4, "ngIf"], [3, "id", "name"], [3, "innerHtml"], [1, "chip-container"], ["solChipQueryContainer", ""], [3, "allowClose", "label", "size", "errorState", "chipTabIndex", "closed", "closeButtonKeydown", "keydown", 4, "ngFor", "ngForOf"], [3, "allowClose", "label", "size", "errorState", "chipTabIndex", "closed", "closeButtonKeydown", "keydown"], ["data-notice", "textInputMaxCharacters", 1, "notice", "visible"], ["width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20ZM10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2Z", "fill", "#3443E1"], ["d", "M10 9.5C10.6 9.5 11 9.9 11 10.5V14.5C11 15 10.6 15.5 10 15.5C9.5 15.5 9 15.1 9 14.5V10.5C9 9.9 9.4 9.5 10 9.5Z", "fill", "#3443E1"], ["d", "M10 4.5C10.6 4.5 11 4.9 11 5.5V6.5C11 7 10.6 7.5 10 7.5C9.5 7.5 9 7.1 9 6.5V5.5C9 4.9 9.4 4.5 10 4.5Z", "fill", "#3443E1"], ["d", "M9.0116 9.97382V5.99476C9.0116 5.39791 9.411 5 10.0101 5C10.5094 5 11.0086 5.39791 11.0086 5.99476V9.97382C11.0086 10.5707 10.5094 10.9686 10.0101 10.9686C9.411 10.9686 9.0116 10.5707 9.0116 9.97382Z", "fill", "#C2041A"], ["d", "M9.0116 13.9529C9.0116 13.356 9.411 12.9581 10.0101 12.9581C10.5094 12.9581 11.0086 13.356 11.0086 13.9529C11.0086 14.5497 10.5094 14.9476 10.0101 14.9476C9.411 14.9476 9.0116 14.5497 9.0116 13.9529Z", "fill", "#C2041A"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M6.27208 0C6.00686 0 5.75251 0.105357 5.56497 0.292893L0.292893 5.56497C0.105357 5.75251 0 6.00686 0 6.27208V13.7279C0 13.9931 0.105357 14.2475 0.292893 14.435L5.56497 19.7071C5.75251 19.8946 6.00686 20 6.27208 20H13.7279C13.9931 20 14.2475 19.8946 14.435 19.7071L19.7071 14.435C19.8946 14.2475 20 13.9931 20 13.7279V6.27208C20 6.00686 19.8946 5.75251 19.7071 5.56497L14.435 0.292893C14.2475 0.105357 13.9931 0 13.7279 0H6.27208ZM2 6.68629L6.68629 2H13.3137L18 6.68629V13.3137L13.3137 18H6.68629L2 13.3137L2 6.68629Z", "fill", "#C2041A"]],
      template: function TagFilterTypeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵelementContainer(2, 2);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, TagFilterTypeComponent_ng_template_3_Template, 1, 11, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(5, TagFilterTypeComponent_ng_template_5_Template, 5, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(7, TagFilterTypeComponent_div_7_Template, 3, 1, "div", 5);
          i0.ɵɵelementStart(8, "div", 6)(9, "div", 7);
          i0.ɵɵtemplate(10, TagFilterTypeComponent_div_10_Template, 3, 2, "div", 8);
          i0.ɵɵelementStart(11, "div", 9);
          i0.ɵɵtemplate(12, TagFilterTypeComponent_12_Template, 1, 0, null, 10);
          i0.ɵɵtext(13);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "div", 11);
          i0.ɵɵtemplate(15, TagFilterTypeComponent_15_Template, 1, 0, null, 10);
          i0.ɵɵtext(16);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "div", 12);
          i0.ɵɵtemplate(18, TagFilterTypeComponent_18_Template, 1, 0, null, 10);
          i0.ɵɵtext(19);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(20, "div", 13);
          i0.ɵɵtext(21);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(22, "div", 14)(23, "sol-button", 15);
          i0.ɵɵlistener("click", function TagFilterTypeComponent_Template_sol_button_click_23_listener() {
            return ctx.clearAllTags();
          });
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "translate");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵtemplate(26, TagFilterTypeComponent_ng_template_26_Template, 4, 0, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor)(28, TagFilterTypeComponent_ng_template_28_Template, 4, 0, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const _r1 = i0.ɵɵreference(4);
          const _r3 = i0.ɵɵreference(6);
          const _r10 = i0.ɵɵreference(27);
          i0.ɵɵproperty("ngClass", "filter-type-tag-" + ctx.setContainerSize);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.inputMode === "text" ? _r1 : _r3);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.tags.length > 0);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.textInputValue.length > ctx.textInputMaxCharacters);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c6, ctx.showNotice.tagLimit));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", _r10);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.queryTagLimitWarning, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c6, ctx.showNotice.duplicateText));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", _r10);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.queryTagDuplicateTextNotice, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c6, ctx.showNotice.unsupportedText));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", _r10);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.queryTagUnsupportedTextNotice, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate2("", ctx.tags.length > 0 ? ctx.tags.length : 0, " / ", ctx.maxTags, "");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("variant", "text")("size", "medium")("disabled", !(ctx.tags.length > 0))("disabledAltState", false);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 20, "clearAll"), " ");
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i3.ButtonComponent, i4.ChipComponent, i5$1.TextAreaComponent, i6.AutoCompleteComponent, i6.AutoCompleteOptionComponent, i7.SpinnerComponent, i8.ɵNgNoValidate, i8.NgControlStatus, i8.NgControlStatusGroup, i8.FormControlDirective, i8.NgForm, i2$1.AsyncPipe, i1$2.TranslationPipe, i6.TextHighlighterPipe],
      styles: [".tag-filter-type{display:flex;flex-direction:column;justify-content:space-between;padding:.438rem;width:31.5rem;max-width:50vw;min-height:5.5rem}.tag-filter-type.filter-type-tag-large{height:19.5rem}.tag-filter-type .chip-container{border-radius:var(--radii-small-allcorners);display:flex;padding:var(--size-8);gap:var(--size-8);overflow-x:hidden;flex-wrap:wrap;overflow-y:auto;max-height:5.75rem;background:#fff}.tag-filter-type .sol-text-area{margin-bottom:.4375rem}.tag-filter-type .mdc-list-item .highlighter{font-weight:700}.tag-filter-type .error{border:1px solid var(--color-interface-error500)}.tag-filter-type .footer-container{display:flex;padding-top:.125rem;font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-headline-h4-line-height)}.tag-filter-type .footer-container .info-cls{padding-top:.25rem;white-space:nowrap}.tag-filter-type .footer-container .notice-container{flex-grow:1;padding-top:.25rem;margin-bottom:-.4375rem;padding-left:.1875rem}.tag-filter-type .footer-container .notice{color:var(--color-interface-text700);transition-property:opacity,padding,height;transition-duration:.3s,.4s,.4s;transition-delay:0s,.3s,.3s;opacity:0;padding:0;height:0;text-overflow:ellipsis;overflow:hidden}.tag-filter-type .footer-container .notice svg{vertical-align:top;margin-right:.25rem}.tag-filter-type .footer-container .notice.visible{transition:0s;padding:0 0 .5rem;opacity:1;height:1.25rem;line-height:1.25rem}.tag-filter-type .footer-container .clear-btn{margin-left:.313rem}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagFilterTypeComponent, [{
    type: Component,
    args: [{
      selector: 'tag-filter-type',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"tag-filter-type\" [ngClass]=\"'filter-type-tag-' + setContainerSize\">\n  <div class=\"input-container\">\n    <ng-container [ngTemplateOutlet]=\"inputMode === 'text' ? text : autocomplete\"></ng-container>\n  </div>\n  <ng-template #text>\n    <sol-text-area\n      [labelText]=\"''\"\n      [placeholder]=\"queryTagInputPlaceholder\"\n      [value]=\"textInputValue\"\n      [disabled]=\"maxTags <= tags.length\"\n      (keydown.enter)=\"addChipToContainerFromTextInput($event)\"\n      [minRows]=\"1\"\n      [maxRows]=\"1\"\n      [cols]=\"70\"\n      [wrap]=\"'off'\"\n      [errorState]=\"isInputError\"\n      [errorMessageText]=\"''\"\n      [resizeTextarea]=\"false\"\n      (keydown.tab)=\"addChipToContainerFromTextInput($event)\"\n      (valueChange)=\"onValueChange($event)\"\n    ></sol-text-area>\n  </ng-template>\n  <ng-template #autocomplete>\n    <form style=\"margin-bottom: 7px\">\n      <sol-autocomplete\n        [formControl]=\"searchTerm\"\n        (optionSelected)=\"addChipToContainerFromAutocomplete($event)\"\n        [minimumSearchTextLength]=\"3\"\n        (dropdownVisible)=\"autocompleteDropdownUpdate($event)\"\n        placeholder=\"item\"\n        ariaLabel=\"item\"\n      >\n        <sol-autocomplete-option *ngIf=\"loading\" id=\"loading\" name=\"loading\" [disabled]=\"true\">\n          <div style=\"height: 40px\">\n            <sol-spinner [isSpinner]=\"loading\" [id]=\"'spinner'\"></sol-spinner>\n          </div>\n        </sol-autocomplete-option>\n        <ng-container *ngFor=\"let option of filteredOptions | async\">\n          <sol-autocomplete-option *ngIf=\"!loading\" [id]=\"option\" [name]=\"objectLabel ? option[objectLabel] : option\">\n            <span [innerHtml]=\"(objectLabel ? option[objectLabel] : option) | solTextHighlighter: searchTerm.value\"></span>\n          </sol-autocomplete-option>\n        </ng-container>\n      </sol-autocomplete>\n    </form>\n  </ng-template>\n  <div class=\"chip-container\" #solChipQueryContainer *ngIf=\"tags.length > 0\">\n    <sol-chip\n      *ngFor=\"let chip of tags; index as index\"\n      [allowClose]=\"true\"\n      [label]=\"chip.label\"\n      [size]=\"'medium'\"\n      [errorState]=\"!chip.isValid\"\n      [chipTabIndex]=\"index == 0 ? '0' : '-1'\"\n      (closed)=\"removeItem(index)\"\n      (closeButtonKeydown)=\"onCloseButtonKeydown($event, index)\"\n      (keydown)=\"onChipKeydown($event, index)\"\n    ></sol-chip>\n  </div>\n  <div class=\"footer-container\">\n    <div class=\"notice-container\">\n      <div class=\"notice visible\" data-notice=\"textInputMaxCharacters\" *ngIf=\"textInputValue.length > textInputMaxCharacters\">\n        <ng-template *ngTemplateOutlet=\"errorIcon\"></ng-template> {{ queryTagInputTextLimitWarning }}\n      </div>\n      <div class=\"notice\" data-notice=\"tagLimit\" [ngClass]=\"{ visible: showNotice.tagLimit }\">\n        <ng-template *ngTemplateOutlet=\"noticeIcon\"></ng-template> {{ queryTagLimitWarning }}\n      </div>\n      <div class=\"notice\" data-notice=\"duplicateText\" [ngClass]=\"{ visible: showNotice.duplicateText }\">\n        <ng-template *ngTemplateOutlet=\"noticeIcon\"></ng-template> {{ queryTagDuplicateTextNotice }}\n      </div>\n      <div class=\"notice\" data-notice=\"unsupportedText\" [ngClass]=\"{ visible: showNotice.unsupportedText }\">\n        <ng-template *ngTemplateOutlet=\"noticeIcon\"></ng-template> {{ queryTagUnsupportedTextNotice }}\n      </div>\n    </div>\n    <div class=\"info-cls\">{{ tags.length > 0 ? tags.length : 0 }} / {{ maxTags }}</div>\n    <div class=\"clear-btn\">\n      <sol-button [variant]=\"'text'\" [size]=\"'medium'\" [disabled]=\"!(tags.length > 0)\" [disabledAltState]=\"false\" (click)=\"clearAllTags()\">\n        {{ 'clearAll' | translate }}\n      </sol-button>\n    </div>\n  </div>\n</div>\n<ng-template #noticeIcon>\n  <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      d=\"M10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20ZM10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2Z\"\n      fill=\"#3443E1\"\n    />\n    <path d=\"M10 9.5C10.6 9.5 11 9.9 11 10.5V14.5C11 15 10.6 15.5 10 15.5C9.5 15.5 9 15.1 9 14.5V10.5C9 9.9 9.4 9.5 10 9.5Z\" fill=\"#3443E1\" />\n    <path d=\"M10 4.5C10.6 4.5 11 4.9 11 5.5V6.5C11 7 10.6 7.5 10 7.5C9.5 7.5 9 7.1 9 6.5V5.5C9 4.9 9.4 4.5 10 4.5Z\" fill=\"#3443E1\" />\n  </svg>\n</ng-template>\n<ng-template #errorIcon>\n  <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      d=\"M9.0116 9.97382V5.99476C9.0116 5.39791 9.411 5 10.0101 5C10.5094 5 11.0086 5.39791 11.0086 5.99476V9.97382C11.0086 10.5707 10.5094 10.9686 10.0101 10.9686C9.411 10.9686 9.0116 10.5707 9.0116 9.97382Z\"\n      fill=\"#C2041A\"\n    />\n    <path\n      d=\"M9.0116 13.9529C9.0116 13.356 9.411 12.9581 10.0101 12.9581C10.5094 12.9581 11.0086 13.356 11.0086 13.9529C11.0086 14.5497 10.5094 14.9476 10.0101 14.9476C9.411 14.9476 9.0116 14.5497 9.0116 13.9529Z\"\n      fill=\"#C2041A\"\n    />\n    <path\n      fill-rule=\"evenodd\"\n      clip-rule=\"evenodd\"\n      d=\"M6.27208 0C6.00686 0 5.75251 0.105357 5.56497 0.292893L0.292893 5.56497C0.105357 5.75251 0 6.00686 0 6.27208V13.7279C0 13.9931 0.105357 14.2475 0.292893 14.435L5.56497 19.7071C5.75251 19.8946 6.00686 20 6.27208 20H13.7279C13.9931 20 14.2475 19.8946 14.435 19.7071L19.7071 14.435C19.8946 14.2475 20 13.9931 20 13.7279V6.27208C20 6.00686 19.8946 5.75251 19.7071 5.56497L14.435 0.292893C14.2475 0.105357 13.9931 0 13.7279 0H6.27208ZM2 6.68629L6.68629 2H13.3137L18 6.68629V13.3137L13.3137 18H6.68629L2 13.3137L2 6.68629Z\"\n      fill=\"#C2041A\"\n    />\n  </svg>\n</ng-template>\n",
      styles: [".tag-filter-type{display:flex;flex-direction:column;justify-content:space-between;padding:.438rem;width:31.5rem;max-width:50vw;min-height:5.5rem}.tag-filter-type.filter-type-tag-large{height:19.5rem}.tag-filter-type .chip-container{border-radius:var(--radii-small-allcorners);display:flex;padding:var(--size-8);gap:var(--size-8);overflow-x:hidden;flex-wrap:wrap;overflow-y:auto;max-height:5.75rem;background:#fff}.tag-filter-type .sol-text-area{margin-bottom:.4375rem}.tag-filter-type .mdc-list-item .highlighter{font-weight:700}.tag-filter-type .error{border:1px solid var(--color-interface-error500)}.tag-filter-type .footer-container{display:flex;padding-top:.125rem;font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-headline-h4-line-height)}.tag-filter-type .footer-container .info-cls{padding-top:.25rem;white-space:nowrap}.tag-filter-type .footer-container .notice-container{flex-grow:1;padding-top:.25rem;margin-bottom:-.4375rem;padding-left:.1875rem}.tag-filter-type .footer-container .notice{color:var(--color-interface-text700);transition-property:opacity,padding,height;transition-duration:.3s,.4s,.4s;transition-delay:0s,.3s,.3s;opacity:0;padding:0;height:0;text-overflow:ellipsis;overflow:hidden}.tag-filter-type .footer-container .notice svg{vertical-align:top;margin-right:.25rem}.tag-filter-type .footer-container .notice.visible{transition:0s;padding:0 0 .5rem;opacity:1;height:1.25rem;line-height:1.25rem}.tag-filter-type .footer-container .clear-btn{margin-left:.313rem}\n"]
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: i1$2.TranslationService
  }], {
    solChipEleRef: [{
      type: ViewChild,
      args: ['solChipQueryContainer', {
        static: false
      }]
    }]
  });
})();
class RangeSliderFilterType extends QueryFilterType {
  constructor(injector) {
    super(injector);
    this.multiValue = new Subject$1();
    this.msgInvalidConfig = '';
    this.originalFormatterCallback = seconds => {
      return '';
    };
    this.showTimeDurationInputTab = false;
    this.activeTabIndex = 0;
    this.saveMetadataFn = () => {
      return {
        activeTabIndex: this.activeTabIndex
      };
    };
    this.loadMetadataFn = metadata => {
      if (metadata && metadata.activeTabIndex) {
        this.activeTabIndex = metadata.activeTabIndex;
      }
    };
  }
  ngOnInit() {
    this.setSliderConfig();
    if (this.filterConfig && this.filterConfig.showTimeDurationInputTab) {
      this.showTimeDurationInputTab = this.filterConfig.showTimeDurationInputTab;
    }
    let pointsCount = 0;
    if (this.sliderConfig && this.sliderConfig.startPoints && this.sliderConfig.startPoints.length) {
      pointsCount = this.sliderConfig.startPoints.length;
    }
    if (pointsCount !== 2) {
      this.msgInvalidConfig = 'Invalid configuration: The range-slider filter type requires exactly 2 points, not ' + pointsCount + '.';
      console.error(this.msgInvalidConfig);
      return;
    }
    this.updateValues();
    this.patchTooltipFormatter();
    this.renderSlider();
    this.subscribeOnValueChange();
  }
  handleSliderValuesUpdate(values, handle, positions) {
    const {
      textIsRtl,
      isRtl,
      isVertical,
      tooltips
    } = this.getSliderProperties();
    const {
      newValues,
      pools,
      poolPositions,
      poolValues
    } = this.initializeSliderValues(values, positions, tooltips);
    let {
      atPool
    } = this.initializeSliderValues(values, positions, tooltips);
    for (let i = 1; i < positions.length; i++) {
      const difference = Math.abs(positions[i] - positions[i - 1]);
      if (this.sliderConfig?.tooltipThreshold && difference < this.sliderConfig.tooltipThreshold) {
        this.updatePoolValues(atPool, i, positions, newValues, pools, poolPositions, poolValues);
      } else {
        atPool++;
        this.createNewPool(atPool, i, positions, newValues, pools, poolPositions, poolValues);
      }
    }
    this.updateTooltips(pools, poolPositions, poolValues, handle, tooltips, textIsRtl, isRtl, isVertical);
  }
  getSliderProperties() {
    const textIsRtl = getComputedStyle(this.componentRef.instance.slider.el.nativeElement).direction === 'rtl';
    const isRtl = this.componentRef.instance.slider.slider.options.direction === 'rtl';
    const isVertical = this.componentRef.instance.slider.slider.options.orientation === 'vertical';
    const tooltips = this.componentRef.instance.slider.slider.getTooltips();
    return {
      textIsRtl,
      isRtl,
      isVertical,
      tooltips
    };
  }
  initializeSliderValues(values, positions, tooltips) {
    const separator = ' - ';
    const pools = [[]];
    const poolPositions = [[]];
    const poolValues = [[]];
    const atPool = 0;
    if (this.componentRef.instance.slider.config.pips.format) {
      const temp = values;
      values = [];
      temp.map(val => values.push(this.componentRef.instance.slider.config.pips.format.from(val)));
    }
    if (tooltips[0]) {
      pools[0][0] = 0;
      poolPositions[0][0] = positions[0];
      poolValues[0][0] = values[0];
    }
    return {
      newValues: values,
      pools,
      poolPositions,
      poolValues,
      atPool
    };
  }
  updatePoolValues(atPool, i, positions, values, pools, poolPositions, poolValues) {
    pools[atPool].push(i);
    poolPositions[atPool].push(positions[i]);
    poolValues[atPool].push(values[i]);
  }
  createNewPool(atPool, i, positions, values, pools, poolPositions, poolValues) {
    pools[atPool] = [i];
    poolPositions[atPool] = [positions[i]];
    poolValues[atPool] = [values[i]];
  }
  updateTooltips(pools, poolPositions, poolValues, handle, tooltips, textIsRtl, isRtl, isVertical) {
    pools.forEach((pool, poolIndex) => {
      const handlesInPool = pool.length;
      const order = handle === 0 ? pool : pool.slice().reverse();
      order.forEach((handleNumber, j) => {
        if (j === handlesInPool - 1) {
          let offset = 0;
          poolPositions[poolIndex].forEach(value => {
            offset += 1000 - value;
          });
          const last = isRtl ? 0 : handlesInPool - 1;
          const lastOffset = 1000 - poolPositions[poolIndex][last];
          offset = (textIsRtl && !isVertical ? 100 : 0) + offset / handlesInPool - lastOffset;
          this.updateTooltipContent(poolValues, poolIndex, handleNumber, tooltips);
          this.componentRef.instance.slider.renderer.setStyle(tooltips[handleNumber], 'display', 'block');
        } else {
          this.componentRef.instance.slider.renderer.setStyle(tooltips[handleNumber], 'display', 'none');
        }
      });
    });
  }
  updateTooltipContent(poolValues, poolIndex, handleNumber, tooltips) {
    const separator = ' - ';
    if (poolValues[poolIndex].length > 1) {
      if (this.componentRef.instance.slider.config.pips.format) {
        tooltips[handleNumber].innerHTML = [this.componentRef.instance.slider.config.pips.format.to(poolValues[poolIndex][0]), this.componentRef.instance.slider.config.pips.format.to(poolValues[poolIndex][1])].join(separator);
      } else {
        tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
      }
    } else if (this.componentRef.instance.slider.config.pips.format) {
      tooltips[handleNumber].innerHTML = [this.componentRef.instance.slider.config.pips.format.to(poolValues[poolIndex][0])].join(separator);
    } else {
      tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.componentRef.instance.slider.slider.on('update', (values, handle, unencoded, tap, positions) => {
        this.handleSliderValuesUpdate(values, handle, positions);
      });
    });
  }
  getStepAndMaxValue(fromValue, range) {
    const keys = Object.keys(range).sort((a, b) => range[a][0] - range[b][0]);
    let closestStep = null;
    let closestDiff = Infinity;
    for (let i = 0; i < keys.length; i++) {
      const rangeValue = range[keys[i]][0];
      const diff = Math.abs(rangeValue - fromValue);
      if (diff < closestDiff) {
        closestDiff = diff;
        closestStep = rangeValue;
      }
    }
    if (closestStep !== null) {
      for (let i = 0; i < keys.length; i++) {
        const rangeValue = range[keys[i]][0];
        if (rangeValue > closestStep) {
          return {
            step: range[keys[i]][1],
            max: rangeValue
          };
        }
      }
    }
    return {
      step: range[keys[keys.length - 1]][1],
      max: range[keys[keys.length - 1]][0]
    };
  }
  getStepAndMinValue(toValue, range) {
    const keys = Object.keys(range).sort((a, b) => range[a][0] - range[b][0]);
    for (let i = 0; i < keys.length; i++) {
      if (range[keys[i]][0] >= toValue && i > 0) {
        return {
          step: range[keys[i - 1]][1],
          min: range[keys[i - 1]][0]
        };
      }
    }
    return {
      step: range[keys[0]][1],
      min: range[keys[0]][0]
    };
  }
  updateRangeSliderStart() {
    if (this.filterConfig.sliderConfig.range && Object.keys(this.filterConfig.sliderConfig.range).length > 2) {
      if (this.start >= this.end) {
        const {
          step: stepValue,
          max: maxValue
        } = this.getStepAndMaxValue(this.start, this.filterConfig.sliderConfig.range);
        this.end = this.start + stepValue;
        if (this.end > maxValue) {
          this.end = maxValue;
        }
      }
    }
    if (this.start > this.end) {
      this.end = this.start;
    }
    this.selection = {
      start: this.start,
      end: this.end
    };
    this.updateValue(this.selection);
    this.componentRef.instance.writeValue([this.start, this.end]);
    this.start = this.oldStartValue;
    this.end = this.oldEndValue;
  }
  updateRangeSliderEnd() {
    if (this.filterConfig.sliderConfig.range && Object.keys(this.filterConfig.sliderConfig.range).length > 2) {
      if (this.end <= this.start) {
        const {
          step: stepValue,
          min: minValue
        } = this.getStepAndMinValue(this.end, this.filterConfig.sliderConfig.range);
        this.start = this.end - stepValue;
        if (this.start < minValue) {
          this.start = minValue;
        }
      }
    }
    if (this.start > this.end && Object.keys(this.filterConfig.sliderConfig.range).length === 2) {
      this.start = this.end - this.filterConfig.sliderConfig.step;
    }
    this.selection = {
      start: this.start,
      end: this.end
    };
    this.updateValue(this.selection);
    this.componentRef.instance.writeValue([this.start, this.end]);
    this.start = this.oldStartValue;
    this.end = this.oldEndValue;
  }
  selectedTab(event) {
    this.activeTabIndex = event.index;
  }
  setSliderConfig() {
    if (this.filterConfig && this.filterConfig.sliderConfig) {
      this.sliderConfig = {
        ...this.filterConfig.sliderConfig
      };
      this.start = this.filterConfig.sliderConfig.startPoints?.[0];
      this.oldStartValue = this.filterConfig.sliderConfig.startPoints?.[0];
      this.end = this.filterConfig.sliderConfig.startPoints?.[1];
      this.oldEndValue = this.filterConfig.sliderConfig.startPoints?.[1];
    }
  }
  updateValues() {
    setTimeout(() => {
      if (this.selection === undefined) {
        this.updateChipValue();
      } else {
        this.updateSliderStartPointsValue();
      }
    });
  }
  updateChipValue() {
    if (this.sliderConfig?.startPoints && this.sliderConfig?.startPoints.length) {
      if (this.sliderConfig?.startPoints.length === 1) {
        this.selection = this.sliderConfig.startPoints[0];
      }
      if (this.sliderConfig?.startPoints.length === 2) {
        this.selection = {
          start: (this.sliderConfig?.startPoints)[0],
          end: (this.sliderConfig?.startPoints)[1]
        };
      }
      if (this.sliderConfig?.startPoints.length > 2) {
        this.selection = this.sliderConfig.startPoints;
      }
    }
    this.updateValue(this.selection);
  }
  updateSliderStartPointsValue() {
    if (typeof this.selection.start == 'number' && typeof this.selection.end == 'number') {
      this.sliderConfig.startPoints = [this.selection.start, this.selection.end];
    } else if (this.selection.length > 2) {
      this.sliderConfig.startPoints = this.selection;
    } else {
      this.sliderConfig.startPoints = [this.selection];
    }
  }
  patchTooltipFormatter() {
    if (this.sliderConfig) {
      if (this.sliderConfig.hasOwnProperty('tooltipFormatter')) {
        this.originalFormatterCallback = this.sliderConfig.tooltipFormatter;
        this.sliderConfig.tooltipFormatter = seconds => {
          this.multiValue.next(seconds);
          return this.originalFormatterCallback(seconds);
        };
      } else {
        this.sliderConfig.tooltipFormatter = seconds => {
          this.multiValue.next(seconds);
          return String(seconds);
        };
      }
    }
  }
  renderSlider() {
    setTimeout(() => {
      this.componentRef = this.slider.createComponent(RangeSliderComponent);
      Object.entries(this.sliderConfig).forEach(v => {
        if (v[0] !== 'tooltipThreshold') {
          const key = v[0];
          const value = v[1];
          this.componentRef.setInput(key, value);
        }
      });
    });
  }
  subscribeOnValueChange() {
    if (this.sliderConfig) {
      this.multiValue.pipe(bufferCount(this.sliderConfig.startPoints ? this.sliderConfig.startPoints.length : 1), distinctUntilChanged((prev, curr) => this.compareArraysValue(prev, curr))).subscribe(v => {
        this.sliderConfig.startPoints = v;
        if (v && v.length === 1) this.selection = v[0];
        if (v && v.length === 2) {
          if (this.filterConfig.sliderConfig?.range) {
            if (v[0] > v[1]) {
              const {
                step: stepValue,
                max: maxValue
              } = this.getStepAndMaxValue(v[0], this.filterConfig.sliderConfig.range);
              v[1] = v[0] + stepValue;
              if (v[1] > maxValue) {
                v[1] = maxValue;
              }
            }
          }
          this.selection = {
            start: v[0],
            end: v[1]
          };
          this.start = v[0];
          this.oldStartValue = v[0];
          this.end = v[1];
          this.oldEndValue = v[1];
        }
        if (v && v.length > 2) this.selection = v;
        setTimeout(() => {
          this.updateValue(this.selection);
        });
      });
    }
  }
  compareArraysValue(prev, curr) {
    return JSON.stringify(prev) === JSON.stringify(curr);
  }
  ngOnDestroy() {
    if (this.slider) {
      this.slider.clear();
    }
    this.multiValue.unsubscribe();
  }
  static {
    this.ɵfac = function RangeSliderFilterType_Factory(t) {
      return new (t || RangeSliderFilterType)(i0.ɵɵdirectiveInject(i0.Injector));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RangeSliderFilterType,
      selectors: [["sol-range-slider-filter-type"]],
      viewQuery: function RangeSliderFilterType_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 5, ViewContainerRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slider = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 1,
      consts: [[1, "range-slider-filter-type"], ["size", "large"], ["size", "large", 3, "selectedTabChange"], ["title", "Slider", 3, "isActive"], [1, "range-slider"], ["slider", ""], ["class", "invalid-config", 4, "ngIf"], ["title", "Input", 3, "isActive"], [1, "time-duration-container"], [1, "time-duration"], [3, "labelText", "ngModel", "ngModelChange", "focusout"], [1, "time-duration-hyphen"], [1, "line"], [1, "invalid-config"]],
      template: function RangeSliderFilterType_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, RangeSliderFilterType_Conditional_1_Template, 14, 7, "sol-tabs", 1)(2, RangeSliderFilterType_Conditional_2_Template, 4, 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(1, ctx.showTimeDurationInputTab ? 1 : 2);
        }
      },
      dependencies: [i2$1.NgIf, i8.NgControlStatus, i8.NgModel, i3$1.TabsComponent, i3$1.TabComponent, i4$1.TimeDurationComponent],
      styles: [".range-slider-filter-type{width:36.5rem;padding:1rem 1.25rem;box-sizing:border-box}.range-slider-filter-type .range-slider{min-width:28rem;height:6.5rem;padding:3rem 1rem 0;box-sizing:border-box}.range-slider-filter-type .mat-mdc-tab-body .range-slider{padding-left:1.75rem;padding-right:1.75rem}.range-slider-filter-type .time-duration-container{display:flex;gap:.75rem;padding:2rem 1rem 1rem}.range-slider-filter-type .time-duration-container .time-duration{width:7.5rem}.range-slider-filter-type .time-duration-container .time-duration-hyphen{margin-top:2.3rem}.range-slider-filter-type .time-duration-container .time-duration-hyphen .line{height:2px;background-color:var(--color-interface-text700);width:.75rem}p.invalid-config{font-size:var(--typography-opensans-body-body3-font-size);margin-bottom:0}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderFilterType, [{
    type: Component,
    args: [{
      selector: 'sol-range-slider-filter-type',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"range-slider-filter-type\">\n  @if (showTimeDurationInputTab) {\n    <sol-tabs size=\"large\" (selectedTabChange)=\"selectedTab($event)\">\n      <sol-tab title=\"Slider\" [isActive]=\"activeTabIndex === 0\">\n        <div class=\"range-slider\">\n          <ng-template #slider></ng-template>\n          <p class=\"invalid-config\" *ngIf=\"msgInvalidConfig\">{{ msgInvalidConfig }}</p>\n        </div>\n      </sol-tab>\n      <sol-tab title=\"Input\" [isActive]=\"activeTabIndex === 1\">\n        <div class=\"time-duration-container\">\n          <div class=\"time-duration\">\n            <sol-time-duration [labelText]=\"'FROM'\" [(ngModel)]=\"start\" (focusout)=\"updateRangeSliderStart()\"></sol-time-duration>\n          </div>\n          <div class=\"time-duration-hyphen\"><div class=\"line\"></div></div>\n          <div class=\"time-duration\">\n            <sol-time-duration [labelText]=\"'TO'\" [(ngModel)]=\"end\" (focusout)=\"updateRangeSliderEnd()\"></sol-time-duration>\n          </div>\n        </div>\n      </sol-tab>\n    </sol-tabs>\n  } @else {\n    <div class=\"range-slider\">\n      <ng-template #slider></ng-template>\n      <p class=\"invalid-config\" *ngIf=\"msgInvalidConfig\">{{ msgInvalidConfig }}</p>\n    </div>\n  }\n</div>\n",
      styles: [".range-slider-filter-type{width:36.5rem;padding:1rem 1.25rem;box-sizing:border-box}.range-slider-filter-type .range-slider{min-width:28rem;height:6.5rem;padding:3rem 1rem 0;box-sizing:border-box}.range-slider-filter-type .mat-mdc-tab-body .range-slider{padding-left:1.75rem;padding-right:1.75rem}.range-slider-filter-type .time-duration-container{display:flex;gap:.75rem;padding:2rem 1rem 1rem}.range-slider-filter-type .time-duration-container .time-duration{width:7.5rem}.range-slider-filter-type .time-duration-container .time-duration-hyphen{margin-top:2.3rem}.range-slider-filter-type .time-duration-container .time-duration-hyphen .line{height:2px;background-color:var(--color-interface-text700);width:.75rem}p.invalid-config{font-size:var(--typography-opensans-body-body3-font-size);margin-bottom:0}\n"]
    }]
  }], () => [{
    type: i0.Injector
  }], {
    slider: [{
      type: ViewChild,
      args: ['slider', {
        read: ViewContainerRef
      }]
    }]
  });
})();
class SelectFilterTypeComponent extends QueryFilterType {
  static {
    this.supportsReadOnly = true;
  }
  constructor(injector) {
    super(injector);
    if (!this.filterConfig) {
      this.filterConfig = {};
    }
  }
  ngOnInit() {}
  selectionChange(newSelection) {
    if (!this.readOnly) {
      this.updateValue(newSelection);
    }
    if (!this.filterConfig.isMultiple) {
      this.closeOverlay();
    }
  }
  static {
    this.ɵfac = function SelectFilterTypeComponent_Factory(t) {
      return new (t || SelectFilterTypeComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SelectFilterTypeComponent,
      selectors: [["sol-select-filter-type"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 1,
      consts: [[1, "select-filter-type"], [3, "selection", "options", "isMultiple", "optionsLabel", "optionsValue", "searchEnabled", "isReadOnly", "projectedContent", "selectionChange", 4, "ngIf"], ["projectedContent", ""], [3, "selection", "options", "isMultiple", "optionsLabel", "optionsValue", "searchEnabled", "isReadOnly", "projectedContent", "selectionChange"], [3, "iconName", "spritePath", "wrapperClass", "ariaLabel", "ariaHidden"]],
      template: function SelectFilterTypeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, SelectFilterTypeComponent_sol_select_1_Template, 1, 8, "sol-select", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, SelectFilterTypeComponent_ng_template_2_Template, 3, 6, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig);
        }
      },
      dependencies: [i2$1.NgIf, i2$2.SvgSpriteIconComponent, i3$2.SelectComponent],
      styles: [".select-filter-type .sol-select{max-width:16rem;border:none}.select-filter-type .sol-select>.sol-options-list .sol-option>.sol-option-text .sol-svg-sprite-icon>svg.select-filter-icon{padding-top:.063rem;width:1rem;height:1rem;margin-right:.5rem;fill:var(--color-interface-text700, #333);stroke:#fff}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectFilterTypeComponent, [{
    type: Component,
    args: [{
      selector: 'sol-select-filter-type',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"select-filter-type\">\n  <sol-select\n    *ngIf=\"filterConfig\"\n    [selection]=\"selection\"\n    [options]=\"filterConfig.options\"\n    [isMultiple]=\"filterConfig.isMultiple\"\n    [optionsLabel]=\"filterConfig.optionsLabel\"\n    [optionsValue]=\"filterConfig.optionsValue\"\n    [searchEnabled]=\"filterConfig.searchEnabled\"\n    [isReadOnly]=\"readOnly\"\n    [projectedContent]=\"projectedContent\"\n    (selectionChange)=\"selectionChange($event)\"\n  ></sol-select>\n</div>\n<ng-template #projectedContent let-optionScope=\"optionScope\">\n  <sol-svg-sprite-icon\n    [iconName]=\"optionScope.projectedData.iconName\"\n    [spritePath]=\"optionScope.projectedData.spritePath\"\n    [wrapperClass]=\"'select-filter-icon'\"\n    [ariaLabel]=\"optionScope.ariaLabel\"\n    [ariaHidden]=\"false\"\n  ></sol-svg-sprite-icon>\n  <span>{{ optionScope.displayText }}</span>\n</ng-template>\n",
      styles: [".select-filter-type .sol-select{max-width:16rem;border:none}.select-filter-type .sol-select>.sol-options-list .sol-option>.sol-option-text .sol-svg-sprite-icon>svg.select-filter-icon{padding-top:.063rem;width:1rem;height:1rem;margin-right:.5rem;fill:var(--color-interface-text700, #333);stroke:#fff}\n"]
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();
class DateRangeFilterTypeComponent extends QueryFilterType {
  constructor(injector, translationService) {
    super(injector);
    this.translationService = translationService;
    this.displayLeftPanel = false;
    this.showTime = false;
    this.disabledDate = this.translationService.getTranslation('disabledDate');
    this.saveMetadataFn = () => {
      if (this.selectedDateRange) {
        return {
          selectedDateRange: this.selectedDateRange
        };
      }
      return;
    };
    this.loadMetadataFn = metadata => {
      if (metadata && metadata.selectedDateRange) {
        this.selectedDateRange = metadata.selectedDateRange;
      }
    };
  }
  ngOnInit() {
    this.setDateRangeWrapperConfig();
    this.selectedDateRange = this.selection;
  }
  setDateRangeWrapperConfig() {
    if (this.filterConfig && this.filterConfig.dateFormat) {
      this.setDateRangeMode(this.filterConfig.dateFormat);
    } else {
      this.setDateRangeMode('shortDate');
    }
    const defaultDateRangeWrapperConfig = {
      min: null,
      max: null,
      startingDay: 0,
      specialDates: []
    };
    if (this.filterConfig && this.filterConfig.dateRangeWrapperConfig) {
      this.dateRangeWrapperConfig = {
        ...defaultDateRangeWrapperConfig,
        ...this.filterConfig.dateRangeWrapperConfig
      };
    } else {
      this.dateRangeWrapperConfig = {
        ...defaultDateRangeWrapperConfig
      };
    }
  }
  setDateRangeMode(format) {
    if (this.isUseDateTimeFormat(format)) {
      this.showTime = true;
      this.displayLeftPanel = false;
    } else {
      this.showTime = false;
      this.displayLeftPanel = true;
    }
  }
  isUseDateTimeFormat(format) {
    if (format.includes('Date')) return false;
    if (format.includes('Time')) return true;
    const timeFormatRegex = /(h{1,2}|H{1,2}|k{1,2}|m{1,2}(?!M)|s{1,2})/g;
    return !!format.match(timeFormatRegex);
  }
  closed(event) {
    if (event === 'clear') {
      this.updateValue(null);
    } else if (event !== 'cancel') {
      this.updateValue(this.selectedDateRange);
    }
    this.selectedDateRange = undefined; // remove the value so that it does not get saved as metadata
    this.closeOverlay();
  }
  dateSelected(v) {
    if (v.start && v.end) {
      this.selectedDateRange = v;
    }
  }
  changeSelectedDate(value) {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - value);
    this.dateSelected(new DateRange(startDate, endDate));
  }
  changeMonth(value) {
    const endDate = new Date();
    const startDate = new Date(endDate);
    if (value > 0) {
      startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth() - value, 1);
      endDate?.setFullYear(startDate.getFullYear(), startDate.getMonth() + value, 0);
      this.dateSelected(new DateRange(startDate, endDate));
    } else {
      startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth(), 1);
      this.dateSelected(new DateRange(startDate, endDate));
    }
  }
  selectNumRange(value) {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - value);
    this.dateSelected(new DateRange(startDate, endDate));
  }
  static {
    this.ɵfac = function DateRangeFilterTypeComponent_Factory(t) {
      return new (t || DateRangeFilterTypeComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$2.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateRangeFilterTypeComponent,
      selectors: [["sol-date-range-filter"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [[3, "startingDay", "min", "max", "specialDates", "displayleftPanel", "showTime", "type", "mode", "overlayState", "ngModel", "closed", "dateSelected", "listSelected", "selectedMonth", "numericSelctorOutput", "ngModelChange", 4, "ngIf"], [3, "startingDay", "min", "max", "specialDates", "displayleftPanel", "showTime", "type", "mode", "overlayState", "ngModel", "closed", "dateSelected", "listSelected", "selectedMonth", "numericSelctorOutput", "ngModelChange"]],
      template: function DateRangeFilterTypeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DateRangeFilterTypeComponent_sol_date_range_wrapper_0_Template, 1, 10, "sol-date-range-wrapper", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.dateRangeWrapperConfig);
        }
      },
      dependencies: [i2$1.NgIf, i8.NgControlStatus, i4$2.DateRangeWrapperComponent, i8.NgModel],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangeFilterTypeComponent, [{
    type: Component,
    args: [{
      selector: 'sol-date-range-filter',
      template: `
    <sol-date-range-wrapper
      *ngIf="dateRangeWrapperConfig"
      [startingDay]="dateRangeWrapperConfig.startingDay!"
      [min]="dateRangeWrapperConfig.min!"
      [max]="dateRangeWrapperConfig.max!"
      [specialDates]="dateRangeWrapperConfig.specialDates!"
      [displayleftPanel]="displayLeftPanel"
      [showTime]="showTime"
      [type]="'range-selection'"
      [mode]="'inline'"
      [overlayState]="false"
      (closed)="closed($event)"
      (dateSelected)="dateSelected($event)"
      (listSelected)="changeSelectedDate($event)"
      (selectedMonth)="changeMonth($event)"
      (numericSelctorOutput)="selectNumRange($event)"
      [(ngModel)]="selectedDateRange"
    ></sol-date-range-wrapper>
  `,
      encapsulation: ViewEncapsulation.None
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: i1$2.TranslationService
  }], null);
})();
class QueryBuilderComponent {
  set model(m) {
    this.modelValue = m;
    this.modelSelectionByIdMap.clear();
    if (m.selection) {
      m.selection.forEach(s => this.modelSelectionByIdMap.set(s.filterId, s));
    }
    this.modelValue.isValid = this.valid;
  }
  get model() {
    return this.modelValue;
  }
  set selection(selection) {
    this.model.selection = selection;
    this.modelSelectionByIdMap.clear();
    selection.forEach(s => this.modelSelectionByIdMap.set(s.filterId, s));
  }
  get selection() {
    return this.model && this.model.selection ? this.model.selection : [];
  }
  get valid() {
    let isValid = false;
    for (const item of this.selection) {
      if (item.value || [0, false].includes(item.value)) {
        isValid = true;
      } else {
        isValid = false;
        break;
      }
    }
    if (this.selection.length === 0) {
      isValid = true;
    }
    return isValid;
  }
  set filters(f) {
    this.filtersArr = f;
    this.filtersByIdMap.clear();
    this.filtersDefaultValueByIdMap.clear();
    this.filtersMandatoryByIdMap.clear();
    this.filtersArr.forEach(fl => {
      if (!this.modelSelectionByIdMap.get(fl.filterId)?.operator && fl.operatorConfig && fl.operatorConfig.options && fl.operatorConfig.options?.length > 0) {
        const filter = this.modelSelectionByIdMap.get(fl.filterId);
        if (filter && fl.operatorConfig?.optionsValue) {
          filter.operator = fl.operatorConfig.options[0][fl.operatorConfig.optionsValue];
        }
      }
      this.filtersByIdMap.set(fl.filterId, fl);
      if (fl.defaultValue) {
        this.filtersDefaultValueByIdMap.set(fl.filterId, fl);
      }
      if (fl.readOnly) fl.mandatory = true;
      if (fl.mandatory) {
        this.filtersMandatoryByIdMap.set(fl.filterId, fl);
      }
    });
  }
  get filters() {
    return this.filtersArr;
  }
  constructor(elementRef, filterTypeRegistry, translationService, cdr) {
    this.elementRef = elementRef;
    this.filterTypeRegistry = filterTypeRegistry;
    this.translationService = translationService;
    this.cdr = cdr;
    this.qbErrorMessage = this.translationService.getTranslation('queryBuilderErrorMessage');
    this.errorMessageText = this.qbErrorMessage;
    this.showErrorMessage = false;
    this.addFilterText = this.translationService.getTranslation('queryAddCriteriaText');
    this.selectionChanged = new EventEmitter();
    this.filtersByIdMap = new Map();
    this.filtersMandatoryByIdMap = new Map();
    this.filtersArr = [];
    this.filtersDefaultValueByIdMap = new Map();
    this.modelSelectionByIdMap = new Map();
    this.modelValue = {};
    this.availableFilters = [];
    this.unselectedFilters = [];
    this.touched = false;
  }
  ngOnInit() {
    this.filterTypeRegistry.add({
      name: 'date-range',
      component: DateRangeFilterTypeComponent
    });
    this.filterTypeRegistry.add({
      name: 'range-slider',
      component: RangeSliderFilterType
    });
    this.filterTypeRegistry.add({
      name: 'tag',
      component: TagFilterTypeComponent
    });
    this.filterTypeRegistry.add({
      name: 'select',
      component: SelectFilterTypeComponent
    });
    if (!this.modelSelectionByIdMap.size) {
      this.model.selection = [];
    }
    this.setMandatoryFilterToModel();
    this.computeAvailableFilters();
    this.setDefaultValue();
  }
  ngAfterViewInit() {
    // since all the chips are not touched by default,
    // marking them as touched
    this.markAllChipsAsTouched();
    this.touched = true;
  }
  markAllChipsAsTouched() {
    this.queryChips.forEach(chip => {
      chip.touched = true;
    });
    this.cdr.detectChanges();
  }
  emitSelectionChanged() {
    this.modelValue.isValid = this.valid;
    this.selectionChanged.emit(this.model);
  }
  onQueryChipTouch() {
    this.touched = true;
    // emit only if invalid because
    // when it is valid, value is changed and
    // event is emitted in onChipValueChanged method
    if (!this.valid) {
      this.emitSelectionChanged();
    }
  }
  addFilterToQuery(filter) {
    const newChipItem = {
      filterId: filter.filterId,
      ...(filter.operatorConfig?.optionsValue && filter.operatorConfig?.options && filter.operatorConfig.options.length > 0 && {
        operator: filter.operatorConfig.options[0][filter.operatorConfig.optionsValue]
      })
    };
    if (this.filtersDefaultValueByIdMap.has(filter.filterId)) {
      newChipItem.value = this.filtersDefaultValueByIdMap.get(filter.filterId).defaultValue;
    }
    this.touched = !this.valid; // if there is no error message, then keep it as not touched else touched "true"
    this.model.selection.push(newChipItem);
    const selectedItemIndex = this.model.selection.findIndex(item => item.filterId === filter.filterId);
    setTimeout(() => {
      const firstItem = this.queryChips.toArray()[selectedItemIndex];
      firstItem?.showOverlay();
    });
    this.computeAvailableFilters();
  }
  updateMenuFilters() {
    this.unselectedFilters = this.availableFilters;
  }
  computeAvailableFilters() {
    this.availableFilters = [];
    if (this.filters && this.filters.length) {
      this.filters.forEach(filter => {
        if (!(this.model.selection && this.model.selection.length && this.model.selection.find(el => el.filterId === filter.filterId))) {
          this.availableFilters.push(filter);
        }
      });
    }
  }
  trackByFn(index, filter) {
    return filter.filterId;
  }
  removeFilterFromQuery(id) {
    if (this.queryChips?.toArray().length > 1) {
      const removedItemIndex = this.queryChips.toArray().findIndex(item => item.definition.filterId === id);
      if (removedItemIndex === 0) {
        const prevItem = this.queryChips.toArray()[1];
        prevItem?.elementRef.nativeElement.querySelector(`[data-filter-id="${prevItem.definition.filterId}"]`).focus();
      } else {
        const nextItem = this.queryChips.toArray()[removedItemIndex - 1];
        nextItem?.elementRef.nativeElement.querySelector(`[data-filter-id="${nextItem.definition.filterId}"]`).focus();
      }
    } else {
      const btnAdd = this.elementRef.nativeElement?.querySelector('.query-add-filters-trigger button');
      if (btnAdd) {
        btnAdd.focus();
      }
    }
    this.model.selection = this.model?.selection?.filter(data => data.filterId !== id);
    this.emitSelectionChanged();
    this.computeAvailableFilters();
  }
  onChipValueChanged(change) {
    if (this.model.selection && change && change.filterId) {
      const changedItem = this.model.selection.find(item => item.filterId === change.filterId);
      if (changedItem && changedItem.value !== change.value) {
        changedItem.value = change.value;
        this.emitSelectionChanged();
      } else if (changedItem && changedItem.operator !== change.operator) {
        changedItem.operator = change.operator;
        this.emitSelectionChanged();
      }
    }
  }
  onFilterMenuClosed(closeReason) {
    // Some notes:
    // 1. The parameter for this function should be type `MenuCloseReason`, but unfortunately
    //    that type is not yet publicly exported by Angular Material. But it should be
    //    exported in a future release: https://github.com/angular/components/issues/26416
    //    export type MenuCloseReason = void | 'click' | 'keydown' | 'tab';
    // 2. By default, closing a mat-menu puts the focus back on the mat-menu-trigger. In
    //    this case, that trigger is sol-button wrapper instead of the real button element.
    //    The code below puts the focus on the button, not the sol-button wrapper.
    // 3. The only time the value of `closeReason` is 'keydown' is when the user closes the
    //    menu with the Escape key. When that happens, we need to put the focus on the button
    //    inside the sol-button.
    // 4. If the user selects an item with the keyboard, the value of `closeReason` is 'click'
    //    because it fires the mat-menu-item's click event. When that happens, we do not need
    //    the below to set the focus; the addFilterToQuery() method will focus the new chip.
    if (closeReason === 'keydown') {
      this.menuTrigger?.buttonText?.nativeElement?.focus();
    }
  }
  setDefaultValue() {
    if (this.filtersDefaultValueByIdMap.size) {
      Array.from(this.filtersDefaultValueByIdMap).forEach(value => {
        const filterId = value[0];
        const defaultValue = value[1].defaultValue;
        if (this.modelSelectionByIdMap.has(filterId) && this.modelSelectionByIdMap.get(filterId).value === undefined) {
          this.modelSelectionByIdMap.get(filterId).value = defaultValue;
        }
      });
    }
  }
  setMandatoryFilterToModel() {
    const mandatoryFromModel = [];
    const mandatoryFromFilters = [];
    Array.from(this.filtersMandatoryByIdMap.values()).forEach(m => {
      const selectedValue = this.modelSelectionByIdMap.get(m.filterId);
      selectedValue ? mandatoryFromModel.push(selectedValue) : mandatoryFromFilters.push({
        filterId: m.filterId
      });
    });
    const selection = new Set([...mandatoryFromModel, ...mandatoryFromFilters, ...this.selection]);
    this.selection = Array.from(selection);
  }
  chipTrackBy(index, item) {
    return item.filterId;
  }
  static {
    this.ɵfac = function QueryBuilderComponent_Factory(t) {
      return new (t || QueryBuilderComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(FilterTypeRegistryService), i0.ɵɵdirectiveInject(i1$2.TranslationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: QueryBuilderComponent,
      selectors: [["sol-query-builder"]],
      viewQuery: function QueryBuilderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c8, 5);
          i0.ɵɵviewQuery(QueryChipComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.queryChips = _t);
        }
      },
      inputs: {
        model: "model",
        filters: "filters",
        errorMessageText: "errorMessageText",
        showErrorMessage: "showErrorMessage",
        addFilterText: "addFilterText"
      },
      outputs: {
        selectionChanged: "selectionChanged"
      },
      decls: 8,
      vars: 9,
      consts: [[1, "sol-query-builder"], [4, "ngIf"], ["type", "button", "variant", "text", "size", "medium", "class", "query-add-filters-trigger", 3, "matMenuTriggerFor", "onClick", 4, "ngIf"], [1, "error-message-container"], ["class", "error-message", 3, "fixed"], [3, "closed"], ["menu", "matMenu"], ["type", "button", "mat-menu-item", "", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "definition", "value", "operator", "chipValueChanged", "chipRemoved", "onTouch"], ["type", "button", "variant", "text", "size", "medium", 1, "query-add-filters-trigger", 3, "matMenuTriggerFor", "onClick"], ["menuTrigger", ""], ["viewBox", "4 4 14 14", "fill", "#003d7a", "xmlns", "http://www.w3.org/2000/svg", 1, "icon-plus"], ["d", "M9 15V11H5C4.73478 11 4.48051 10.8946 4.29297 10.7071C4.10543 10.5196 4 10.2652 4 10C4 9.73478 4.10543 9.48043 4.29297 9.29289C4.48051 9.10536 4.73478 9 5 9H9V5C9 4.73478 9.10543 4.48043 9.29297 4.29289C9.4805 4.10536 9.73478 4 10 4C10.2652 4 10.5195 4.10536 10.707 4.29289C10.8946 4.48043 11 4.73478 11 5V9H15C15.2652 9 15.5195 9.10536 15.707 9.29289C15.8946 9.48043 16 9.73478 16 10C16 10.2652 15.8946 10.5196 15.707 10.7071C15.5195 10.8946 15.2652 11 15 11H11V15C11 15.2652 10.8946 15.5196 10.707 15.7071C10.5195 15.8946 10.2652 16 10 16C9.73478 16 9.4805 15.8946 9.29297 15.7071C9.10543 15.5196 9 15.2652 9 15Z"], [1, "error-message"], ["type", "button", "mat-menu-item", "", 3, "click"]],
      template: function QueryBuilderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, QueryBuilderComponent_ng_container_1_Template, 2, 2, "ng-container", 1)(2, QueryBuilderComponent_sol_button_2_Template, 5, 2, "sol-button", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵtemplate(4, QueryBuilderComponent_Conditional_4_Template, 2, 3, "div", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "mat-menu", 5, 6);
          i0.ɵɵlistener("closed", function QueryBuilderComponent_Template_mat_menu_closed_5_listener($event) {
            return ctx.onFilterMenuClosed($event);
          });
          i0.ɵɵtemplate(7, QueryBuilderComponent_button_7_Template, 2, 1, "button", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("invalid", ctx.showErrorMessage);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.model && ctx.model.selection && ctx.model.selection.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableFilters && ctx.availableFilters.length);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(4, ctx.showErrorMessage ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassMap("sol-mat-menu-panel query-add-filters-panel offset-left-one-rem add-box-shadow");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.unselectedFilters)("ngForTrackBy", ctx.trackByFn);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i4$3.MatMenu, i4$3.MatMenuItem, i4$3.MatMenuTrigger, i3.ButtonComponent, QueryChipComponent],
      styles: [".sol-query-builder[_ngcontent-%COMP%]{border:1px solid var(--color-button-basic-border);border-radius:var(--radii-small-allcorners);background:#fff;padding:.4375rem;display:flex;align-items:top;flex-flow:row wrap;gap:.5rem}.sol-query-builder.invalid[_ngcontent-%COMP%]{border-color:var(--color-interface-error600)}.sol-query-builder[_ngcontent-%COMP%]   sol-query-chip[_ngcontent-%COMP%]{display:block;margin:0}.sol-query-builder[_ngcontent-%COMP%]   sol-button.query-add-filters-trigger[_ngcontent-%COMP%]{margin:0}.sol-query-builder[_ngcontent-%COMP%]   sol-button.query-add-filters-trigger[_ngcontent-%COMP%]   svg.icon-plus[_ngcontent-%COMP%]{height:15px;width:15px}.sol-query-builder[_ngcontent-%COMP%] + .error-message-container[_ngcontent-%COMP%]{position:relative;min-height:var(--typography-opensans-body-body1-line-height);padding:.25rem 0 0}.sol-query-builder[_ngcontent-%COMP%] + .error-message-container[_ngcontent-%COMP%]   .error-message[_ngcontent-%COMP%]{color:var(--color-interface-error600);max-width:100%;font-family:var(--typography-opensans-body-body1-font-family);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-size:var(--typography-opensans-body-body1-font-size);line-height:var(--typography-opensans-body-body1-line-height);text-decoration:var(--typography-opensans-body-body1-text-decoration);letter-spacing:var(--typography-opensans-body-body1-letter-spacing);text-transform:var(--typography-opensans-body-body1-text-case)}.sol-query-builder[_ngcontent-%COMP%] + .error-message-container[_ngcontent-%COMP%]   .error-message.fixed[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QueryBuilderComponent, [{
    type: Component,
    args: [{
      selector: 'sol-query-builder',
      template: "<div class=\"sol-query-builder\" [class.invalid]=\"showErrorMessage\">\n  <ng-container *ngIf=\"this.model && this.model.selection && this.model.selection.length\">\n    <div *ngFor=\"let selectedFilter of this.model.selection; trackBy: chipTrackBy\">\n      <sol-query-chip\n        [definition]=\"filtersByIdMap.get(selectedFilter.filterId)!\"\n        [value]=\"selectedFilter.value\"\n        [operator]=\"selectedFilter.operator\"\n        (chipValueChanged)=\"onChipValueChanged($event)\"\n        (chipRemoved)=\"removeFilterFromQuery($event)\"\n        (onTouch)=\"onQueryChipTouch()\"\n      ></sol-query-chip>\n    </div>\n  </ng-container>\n  <sol-button\n    type=\"button\"\n    #menuTrigger\n    *ngIf=\"availableFilters && availableFilters.length\"\n    variant=\"text\"\n    [matMenuTriggerFor]=\"menu\"\n    (onClick)=\"updateMenuFilters()\"\n    size=\"medium\"\n    class=\"query-add-filters-trigger\"\n  >\n    <svg viewBox=\"4 4 14 14\" fill=\"#003d7a\" xmlns=\"http://www.w3.org/2000/svg\" class=\"icon-plus\">\n      <path\n        d=\"M9 15V11H5C4.73478 11 4.48051 10.8946 4.29297 10.7071C4.10543 10.5196 4 10.2652 4 10C4 9.73478 4.10543 9.48043 4.29297 9.29289C4.48051 9.10536 4.73478 9 5 9H9V5C9 4.73478 9.10543 4.48043 9.29297 4.29289C9.4805 4.10536 9.73478 4 10 4C10.2652 4 10.5195 4.10536 10.707 4.29289C10.8946 4.48043 11 4.73478 11 5V9H15C15.2652 9 15.5195 9.10536 15.707 9.29289C15.8946 9.48043 16 9.73478 16 10C16 10.2652 15.8946 10.5196 15.707 10.7071C15.5195 10.8946 15.2652 11 15 11H11V15C11 15.2652 10.8946 15.5196 10.707 15.7071C10.5195 15.8946 10.2652 16 10 16C9.73478 16 9.4805 15.8946 9.29297 15.7071C9.10543 15.5196 9 15.2652 9 15Z\"\n      />\n    </svg>\n    {{ addFilterText }}\n  </sol-button>\n</div>\n\n<div class=\"error-message-container\">\n  @if (showErrorMessage) {\n    <div class=\"error-message\" [class.fixed]=\"true\">{{ errorMessageText }}</div>\n  }\n</div>\n\n<mat-menu\n  #menu=\"matMenu\"\n  [class]=\"'sol-mat-menu-panel query-add-filters-panel offset-left-one-rem add-box-shadow'\"\n  (closed)=\"onFilterMenuClosed($event)\"\n>\n  <button type=\"button\" mat-menu-item *ngFor=\"let filter of unselectedFilters; trackBy: trackByFn\" (click)=\"addFilterToQuery(filter)\">\n    {{ filter.filterName }}\n  </button>\n</mat-menu>\n",
      styles: [".sol-query-builder{border:1px solid var(--color-button-basic-border);border-radius:var(--radii-small-allcorners);background:#fff;padding:.4375rem;display:flex;align-items:top;flex-flow:row wrap;gap:.5rem}.sol-query-builder.invalid{border-color:var(--color-interface-error600)}.sol-query-builder sol-query-chip{display:block;margin:0}.sol-query-builder sol-button.query-add-filters-trigger{margin:0}.sol-query-builder sol-button.query-add-filters-trigger svg.icon-plus{height:15px;width:15px}.sol-query-builder+.error-message-container{position:relative;min-height:var(--typography-opensans-body-body1-line-height);padding:.25rem 0 0}.sol-query-builder+.error-message-container .error-message{color:var(--color-interface-error600);max-width:100%;font-family:var(--typography-opensans-body-body1-font-family);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-size:var(--typography-opensans-body-body1-font-size);line-height:var(--typography-opensans-body-body1-line-height);text-decoration:var(--typography-opensans-body-body1-text-decoration);letter-spacing:var(--typography-opensans-body-body1-letter-spacing);text-transform:var(--typography-opensans-body-body1-text-case)}.sol-query-builder+.error-message-container .error-message.fixed{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: FilterTypeRegistryService
  }, {
    type: i1$2.TranslationService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    menuTrigger: [{
      type: ViewChild,
      args: ['menuTrigger']
    }],
    model: [{
      type: Input
    }],
    filters: [{
      type: Input
    }],
    errorMessageText: [{
      type: Input
    }],
    showErrorMessage: [{
      type: Input
    }],
    addFilterText: [{
      type: Input
    }],
    selectionChanged: [{
      type: Output
    }],
    queryChips: [{
      type: ViewChildren,
      args: [QueryChipComponent]
    }]
  });
})();
class DemoFilterTypeComponent extends QueryFilterType {
  // QueryFilterType
  // ---------------
  // selection: any;
  // filterConfig: any;
  // updateValue(value: any);
  // closeOverlay();
  constructor(injector) {
    super(injector);
  }
  ngOnInit() {
    console.log(this.selection);
    console.log(this.filterConfig);
  }
  clickButton(text) {
    this.updateValue(text);
  }
  static {
    this.ɵfac = function DemoFilterTypeComponent_Factory(t) {
      return new (t || DemoFilterTypeComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DemoFilterTypeComponent,
      selectors: [["sol-demo-dynamic-filter-type"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 4,
      consts: [[1, "filter-type-editor"], [4, "ngIf"], [2, "margin-bottom", "0"], ["style", "border: 0; padding: 0; background: transparent; color: #666; cursor: pointer", 3, "click", 4, "ngIf"], [3, "click"], [2, "border", "0", "padding", "0", "background", "transparent", "color", "#666", "cursor", "pointer", 3, "click"]],
      template: function DemoFilterTypeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, DemoFilterTypeComponent_div_1_Template, 3, 1, "div", 1)(2, DemoFilterTypeComponent_div_2_Template, 3, 1, "div", 1);
          i0.ɵɵelementStart(3, "p", 2)(4, "strong");
          i0.ɵɵtext(5, "Value");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(6, "br");
          i0.ɵɵtext(7);
          i0.ɵɵtemplate(8, DemoFilterTypeComponent_button_8_Template, 2, 0, "button", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.btn1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.btn2);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1("", ctx.selection, "\xA0");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.selection);
        }
      },
      dependencies: [i2$1.NgIf],
      styles: [".filter-type-editor[_ngcontent-%COMP%]{padding:.25rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DemoFilterTypeComponent, [{
    type: Component,
    args: [{
      selector: 'sol-demo-dynamic-filter-type',
      template: "<div class=\"filter-type-editor\">\n  <div *ngIf=\"filterConfig && filterConfig.btn1\">\n    <button (click)=\"clickButton(filterConfig.btn1)\">{{ filterConfig.btn1 }}</button>\n  </div>\n  <div *ngIf=\"filterConfig && filterConfig.btn2\">\n    <button (click)=\"clickButton(filterConfig.btn2)\">{{ filterConfig.btn2 }}</button>\n  </div>\n  <p style=\"margin-bottom: 0\">\n    <strong>Value</strong><br />{{ selection }}&nbsp;<button\n      *ngIf=\"selection\"\n      style=\"border: 0; padding: 0; background: transparent; color: #666; cursor: pointer\"\n      (click)=\"clickButton(undefined)\"\n    >\n      \u00D7\n    </button>\n  </p>\n</div>\n",
      styles: [".filter-type-editor{padding:.25rem}\n"]
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();
class TestDisplayFilterTypeComponent extends QueryFilterType {
  constructor(injector) {
    super(injector);
    // QueryFilterType
    // ---------------
    // selection: any;
    // filterConfig: any;
    // updateValue(value: any);
    // closeOverlay();
    this.dateSingle = new Date('October 26, 1985');
    this.dateRange = {
      start: new Date('November 5, 1955'),
      end: new Date('November 12, 1955')
    };
    if (!this.filterConfig) {
      this.filterConfig = {};
    }
    if (!this.filterConfig.subtype) {
      this.filterConfig.subtype = 'string';
    }
  }
  ngOnInit() {}
  clickButton(text) {
    this.updateValue(text);
  }
  static {
    this.ɵfac = function TestDisplayFilterTypeComponent_Factory(t) {
      return new (t || TestDisplayFilterTypeComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TestDisplayFilterTypeComponent,
      selectors: [["sol-test-display-filter-type"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 9,
      consts: [[1, "filter-type-editor"], [4, "ngIf"], ["aria-label", "Selection", "disabled", ""], [3, "click"]],
      template: function TestDisplayFilterTypeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, TestDisplayFilterTypeComponent_ul_1_Template, 16, 0, "ul", 1)(2, TestDisplayFilterTypeComponent_ul_2_Template, 19, 0, "ul", 1)(3, TestDisplayFilterTypeComponent_ul_3_Template, 10, 0, "ul", 1)(4, TestDisplayFilterTypeComponent_ul_4_Template, 16, 0, "ul", 1)(5, TestDisplayFilterTypeComponent_ul_5_Template, 25, 0, "ul", 1)(6, TestDisplayFilterTypeComponent_ul_6_Template, 10, 0, "ul", 1);
          i0.ɵɵelementStart(7, "textarea", 2);
          i0.ɵɵtext(8);
          i0.ɵɵpipe(9, "json");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.subtype === "number");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.subtype === "string");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.subtype === "lookup");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.subtype === "object");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.subtype === "custom");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterConfig && ctx.filterConfig.subtype === "date");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 7, ctx.selection));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.JsonPipe],
      styles: [".filter-type-editor[_ngcontent-%COMP%]{padding:.5rem}ul[_ngcontent-%COMP%]{list-style:none;padding:0 0 .5rem;margin:0;font-size:.875rem}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:0;margin:0 0 .25rem}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{min-width:200px;text-align:left;cursor:pointer;background:transparent;border:0;font-size:.875rem;padding:.25rem}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{text-decoration:underline}textarea[_ngcontent-%COMP%]{width:250px;height:100px;font-size:.75rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TestDisplayFilterTypeComponent, [{
    type: Component,
    args: [{
      selector: 'sol-test-display-filter-type',
      template: "<div class=\"filter-type-editor\">\n  <ul *ngIf=\"filterConfig && filterConfig.subtype === 'number'\">\n    <li><button (click)=\"updateValue(0)\">Single Number (0)</button></li>\n    <li><button (click)=\"updateValue(20)\">Single Number (20)</button></li>\n    <li><button (click)=\"updateValue([42])\">Array of 1 Number</button></li>\n    <li><button (click)=\"updateValue([42, 43])\">Array of 2 Numbers</button></li>\n    <li><button (click)=\"updateValue({ start: 48, end: 120 })\">Range of Numbers</button></li>\n  </ul>\n  <ul *ngIf=\"filterConfig && filterConfig.subtype === 'string'\">\n    <li><button (click)=\"updateValue('Blue')\">Single String</button></li>\n    <li><button (click)=\"updateValue(['Purple'])\">Array of 1 String</button></li>\n    <li><button (click)=\"updateValue(['Blue', 'Red'])\">Array of 2 Strings</button></li>\n    <li><button (click)=\"updateValue([])\">Empty Array</button></li>\n    <li><button (click)=\"updateValue(null)\">Null</button></li>\n    <li><button (click)=\"updateValue(undefined)\">Undefined</button></li>\n  </ul>\n  <ul *ngIf=\"filterConfig && filterConfig.subtype === 'lookup'\">\n    <li><button (click)=\"updateValue(filterConfig.options[0][filterConfig.optionsValue])\">Single Lookup</button></li>\n    <li>\n      <button (click)=\"updateValue([filterConfig.options[filterConfig.options.length - 1][filterConfig.optionsValue]])\">Array of 1 Lookup</button>\n    </li>\n    <li>\n      <button\n        (click)=\"\n          updateValue([\n            filterConfig.options[0][filterConfig.optionsValue],\n            filterConfig.options[filterConfig.options.length - 1][filterConfig.optionsValue]\n          ])\n        \"\n      >\n        Array of 2 Lookups\n      </button>\n    </li>\n  </ul>\n  <ul *ngIf=\"filterConfig && filterConfig.subtype === 'object'\">\n    <li><button (click)=\"updateValue({ id: 1, description: 'Gryffindor', color: 'Red' })\">Single Object</button></li>\n    <li><button (click)=\"updateValue([{ id: 2, description: 'Ravenclaw', color: 'Blue' }])\">Array of 1 Object</button></li>\n    <li>\n      <button\n        (click)=\"\n          updateValue([\n            { id: 3, description: 'Hufflepuff', color: 'Yellow' },\n            { id: 4, description: 'Slytherin', color: 'Green' }\n          ])\n        \"\n      >\n        Array of 2 Objects\n      </button>\n    </li>\n    <li><button (click)=\"updateValue({ id: 1, name: 'Hogwarts' })\">Object Missing Property</button></li>\n    <li><button (click)=\"updateValue([])\">Empty Array</button></li>\n  </ul>\n  <ul *ngIf=\"filterConfig && filterConfig.subtype === 'custom'\">\n    <li><button (click)=\"updateValue(0)\">0</button></li>\n    <li><button (click)=\"updateValue(5)\">5</button></li>\n    <li><button (click)=\"updateValue(150)\">150</button></li>\n    <li><button (click)=\"updateValue(6000)\">6000</button></li>\n    <li><button (click)=\"updateValue(82800)\">82800</button></li>\n    <li><button (click)=\"updateValue([6000])\">Array of 1 number</button></li>\n    <li><button (click)=\"updateValue([1000, 2000, 3000, 4000, 5000])\">Array of 5 numbers</button></li>\n    <li><button (click)=\"updateValue({ start: 600, end: 3600 })\">Range</button></li>\n  </ul>\n  <ul *ngIf=\"filterConfig && filterConfig.subtype === 'date'\">\n    <li><button (click)=\"updateValue(dateSingle)\">Single Date</button></li>\n    <li><button (click)=\"updateValue(dateRange)\">Range of Dates</button></li>\n    <li><button (click)=\"updateValue(undefined)\">Undefined</button></li>\n  </ul>\n  <textarea aria-label=\"Selection\" disabled>{{ selection | json }}</textarea>\n</div>\n",
      styles: [".filter-type-editor{padding:.5rem}ul{list-style:none;padding:0 0 .5rem;margin:0;font-size:.875rem}ul li{padding:0;margin:0 0 .25rem}ul li button{min-width:200px;text-align:left;cursor:pointer;background:transparent;border:0;font-size:.875rem;padding:.25rem}ul li button:hover{text-decoration:underline}textarea{width:250px;height:100px;font-size:.75rem}\n"]
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();
class QueryBuilderModule {
  static {
    this.ɵfac = function QueryBuilderModule_Factory(t) {
      return new (t || QueryBuilderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: QueryBuilderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [languageInitializerProvider],
      imports: [A11yModule, CommonModule, MatMenuModule, TranslationModule, OverlayModule, ButtonModule, CheckboxModule, PortalModule, RangeSliderModule, ChipModule, TextInputModule, TextAreaModule, AutoCompleteModule, SpinnerModule, ReactiveFormsModule, DateRangepickerModule, FormsModule, TooltipModule, SvgSpriteIconModule, TabsModule, TimeDurationModule, SelectModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QueryBuilderModule, [{
    type: NgModule,
    args: [{
      declarations: [QueryBuilderComponent, QueryChipComponent, DemoFilterTypeComponent, QueryChipOverlayComponent, RangeSliderFilterType, TestDisplayFilterTypeComponent, TagFilterTypeComponent, SelectFilterTypeComponent, DateRangeFilterTypeComponent],
      imports: [A11yModule, CommonModule, MatMenuModule, TranslationModule, OverlayModule, ButtonModule, CheckboxModule, PortalModule, RangeSliderModule, ChipModule, TextInputModule, TextAreaModule, AutoCompleteModule, SpinnerModule, ReactiveFormsModule, DateRangepickerModule, FormsModule, TooltipModule, SvgSpriteIconModule, TabsModule, TimeDurationModule, SelectModule],
      exports: [QueryBuilderComponent, QueryChipComponent, DemoFilterTypeComponent, TestDisplayFilterTypeComponent, TagFilterTypeComponent, SelectFilterTypeComponent, DateRangeFilterTypeComponent],
      providers: [languageInitializerProvider]
    }]
  }], null, null);
})();

/*
 * Public API Surface of query-builder
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DateRangeFilterTypeComponent, DemoFilterTypeComponent, FilterTypeRegistryService, QueryBuilderComponent, QueryBuilderModule, QueryChipComponent, QueryFilterType, RangeSliderFilterType, SelectFilterTypeComponent, TagFilterTypeComponent, TestDisplayFilterTypeComponent };
